import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../global.service';
import { BookAppointment, Productinfo, HospitalDetails, ReferralSourceDtls, CommunicationDetails, PaymentConfirmationObj, LeadObject, searchDoctorsObj } from '../Class/BookAppointment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FilterPipe } from 'ngx-filter-pipe';
import { environment } from '../../environments/environment';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import * as moment from 'moment';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  HospitalDoctorData;
  COVID19Quetions;
  FinalCovidQuestionArray;
  OrganizationSettingsData;
  MasterReferralSouceData;
  SubReferralSouceData;

  PrintOrganizationSettingsData: any = {
    "PrintHeaderImgUrl": "",
    "PluginHeaderImgUrl": "",
    "PluginFooterImgUrl": "",
    "PluginHeaderNavigationUrl": ""
  };
  minDate: Date;
  SelectedHospital: any;
  SelectedHospitalId;
  SelectedDoctorData;
  SelectedDoctor: any;
  SelectedDoctorId;
  SelectedUserBranchId;
  CityArrayList: any[];;
  NewCityArrayList: any[];;
  SelectedCity;
  SelectedDate;
  currentdate;
  selectedFromDate = new Date().setDate(new Date().getDate() + 2);
  chunkedData;
  HospitalFilterLIst;
  BranchSubSpecializationList: any[];;
  WorkingBranchsList: any[];;
  ParentHospitalDetails;
  HospitalDoctorSlotsData;
  SlectedSlots;
  errorMessage;
  interval;
  displayTimer;
  IsPatientExits?: boolean;
  ResendotpButton: boolean = false;
  hospitalshow: boolean = true;
  branchSelectionshow: boolean = false;
  branchAddressInfoshow: boolean = false;
  DoctorSelectionshow: boolean = false;
  isDoctorSelected: boolean = false;
  doctorNotSelected: boolean = false;
  filterBYBranchorDoc: boolean = false;
  withOutDocFinalConfirmation: boolean = false;
  FinalInformationshow: boolean = false;
  CovidQuetionss: boolean = false;
  ConsentFormSign: boolean = false;
  ShowPaymentForm: boolean = false;
  FinalDetailScreenshow: boolean = false;
  OtpAndVerifyScreenshow: boolean = true;
  OtpContactScreenshow: boolean = true;
  ExistingPatientList: any;
  IsTeleSlot: boolean;
  consultationFee: number;
  newSelectedBranchId: any;
  avgConsultationTime: number;
  doctorBookedSlots;
  normalConsultationSlots: any;
  teleConsultationSlots: any;
  hospitalFilter: any = "";
  filterindex: number = 0;
  SelectedParentHospitalId: number;
  SelectedSubOrganizationId: number;
  ShowSuccessForm: boolean = false;
  IsPluginAppointmentBookingFree: boolean = false;
  showAppointmentTypeSlection: boolean = false;
  CountryID: number;
  CountryCode: any;
  slotappointmenttype: any = {
    "value": "0"
  }
  filterBranchOrDoctype: any = {
    "value": "0"//BranchFilter
  }
  slotappointmenttypeInd: boolean = false;
  filtertypeInd: boolean = true;
  directdoctorId: number = 0;
  SelectedBranchInfo: any = {
    MobileNo: "",
    Email: "",
    Address: ""
  }
  SerarchPatient: any = {
    SearchContactNo: "",
    GeneratedOTP: "",
    GeneratedOTP1: "",
    GeneratedOTP2: "",
    GeneratedOTP3: "",
    GeneratedOTP4: ""
  }
  promoCodeObj: any = {
    promoCode: "",
    promoCodeApplied: false,
    promoCodeValid: false,
    OfferValue: "",
    OfferValueType: "",
    OfferAmount: "",
    PatientId: ""
  }
  branchFilter: any = {
    "HospitalInfo": {
      "HospitalDetails": {
        "HospitalName": ""
      }
    }
  };
  doctorFilter: any = {
    "FullName": ""
  }
  isPaidSlot: boolean = false;
  ChildMerchantId: string;
  walkinConsultationFee: number;
  teleConsultationFee: number;
  walkinCommissionFee: number;
  teleCommissionFee: number;
  walkinCommissionwithGst: number;
  teleCommissionWithGst: number;
  gstPercentage: number;
  additionalCharges: number;
  totalAmount: number;
  userfreeFollowUp: boolean;
  //branchLoggedinId: number;
  branchLoggedinId: string;
  appointmentType: string;
  @ViewChild('otp2') searchElement1: ElementRef;
  @ViewChild('otp3') searchElement2: ElementRef;
  @ViewChild('otp4') searchElement3: ElementRef;
  BranchSubSpecializationId;
  SubSpecializationId;
  showTeleType: string = '2';
  //commission
  slotsMorningFilter(user: any) {
    return parseInt(user.Sequence) <= 1200 && user.Available == 'Y';
  }
  slotsAfterNoonFilter(user: any) {
    return (parseInt(user.Sequence) > 1200 && parseInt(user.Sequence) <= 1700) && user.Available == 'Y';
  }
  slotsEveningFilter(user: any) {
    return (parseInt(user.Sequence) > 1700 && parseInt(user.Sequence) <= 2000) && user.Available == 'Y';
  }
  slotsNightFilter(user: any) {
    return (parseInt(user.Sequence) > 2000 && parseInt(user.Sequence) <= 2400) && user.Available == 'Y';
  }

  getShortName(fullName) {
    var abc = fullName.split(' ').map(n => n[0]).join('');
    return abc.substring(0, 2);
  }

  DisableCalender(Date) {
    var abc = false;
    if (this.datePipe.transform(Date, 'yyyy-MM-dd') === this.datePipe.transform(this.currentdate, 'yyyy-MM-dd')) {
      abc = true;
    }
    return abc;
  }

  SortRowId(item: any) {
    return function (FinalCovidQuestionArray, field, reverse) {
      var filtered = [];
      this.forEach(FinalCovidQuestionArray, function (item) {
        filtered.push(item);
      });
      filtered.sort(function (a, b) {
        return (a[field] > b[field] ? 1 : -1);
      });
      if (reverse) filtered.reverse();
      return filtered;
    };


  }

  selectedBooAppointmentData;
  public bookAppointment: BookAppointment;
  public productinfo: Productinfo;
  private hospitalDetails: HospitalDetails;
  private referralSourceDtls: ReferralSourceDtls;
  private communicationDetails: CommunicationDetails;
  public PaymentConfirmationObj: PaymentConfirmationObj;
  private searchDoctorsObj: searchDoctorsObj;
  public leadObject: LeadObject;
  httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
  options = {
    headers: this.httpHeaders
  };
  DoctorSlots;
  maxDate: Date;
  myform: FormGroup;
  myleadform: FormGroup;
  firstName: FormControl;
  lastName: FormControl;
  email: FormControl;
  mobile: FormControl;
  gender: FormControl;
  datePicker: FormControl;
  ///headers: Headers = new Headers({ 'Content-Type': 'application/json' });


  ////options: RequestOptions = new RequestOptions({ headers: this.headers });
  //options: {
  //  headers?: HttpHeaders | {
  //    [header: string]: string | string[];
  //  };
  //}
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private router: Router, private globalService: GlobalService, private activeRoute: ActivatedRoute, private ngxLoader: NgxUiLoaderService, private myElement: ElementRef, private datePipe: DatePipe, private toastr: ToastrService) {

  }

  onHospitalSelected(user: any): void {
    this.branchSelectionshow = false;
    this.branchAddressInfoshow = true;
    this.SelectedHospital = user;

    this.SelectedHospitalId = user.HospitalInfo.HospitalDetails.HospitalID;
    this.searchDoctorsObj.BranchId = user.HospitalInfo.HospitalDetails.HospitalID;
    this.BranchSubSpecializationList = user.BranchSubSpecialization;

    this.IsPluginAppointmentBookingFree = user.HospitalInfo.HospitalDetails.IsPluginAppointmentBookingFree || false;



    var allBranchSpecializationObj = {
      "BranchSubSpecializationId": 0,
      "SpecializationId": 0,
      "SubSpecializationId": 0,
      "SubSpecializationName": "All Specializations"
    };
    this.searchDoctorsObj.SubSpecializationId = 0;
    this.searchDoctorsObj.AllSubSpecializationInd = 1;
    this.BranchSubSpecializationList.unshift(allBranchSpecializationObj);

    this.getAllDoctors(this.SelectedHospitalId, this.searchDoctorsObj.SubSpecializationId);
    this.SelectedBranchInfo.MobileNo = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.SelectedBranchInfo.Email = this.SelectedHospital.HospitalInfo.HospitalDetails.EmailAddress;

    var address = "";
    if (this.SelectedHospital.HospitalInfo.HospitalAddress.Address1 != "" && this.SelectedHospital.HospitalInfo.HospitalAddress.Address1 != undefined && this.SelectedHospital.HospitalInfo.HospitalAddress.Address1 == null) {
      address = this.SelectedHospital.HospitalInfo.HospitalAddress.Address1 + "," + this.SelectedHospital.HospitalInfo.HospitalAddress.Address2;
    } else {
      address = this.SelectedHospital.HospitalInfo.HospitalAddress.Address2;
    }

    this.SelectedBranchInfo.Address = address;
    //this.SelectedDoctorData = user.DoctorDetails.filter((item) => (item.RoleId === 1 || item.RoleId === 3 || item.RoleId === 4 || item.RoleId === 43 || item.RoleId === 16 || item.RoleId === 56 || item.RoleId === 57));


    //this.SelectedDoctorData.forEach((subitem, index) => {


    //  subitem.doctorotherinfo = "";

    //  var Designation = "", DoctorSpecialization = "", Experience = "";
    //  if (subitem.Designation != '') {
    //    Designation = subitem.Designation + " ,";
    //  }
    //  if (subitem.DoctorSpecialization != '') {
    //    DoctorSpecialization = subitem.DoctorSpecialization + " ,";
    //  }
    //  if (subitem.Experience != '' && subitem.Experience != null && subitem.Experience != undefined) {
    //    Experience = subitem.Experience +' Years Experience Overall';
    //  }
    //  subitem.doctorotherinfo = Designation + "" + DoctorSpecialization + "" + Experience;


    //});

    this.chunkedData = [];
    //this.SelectedDoctor = {};
    this.SelectedDoctorId = "";
    this.HospitalDoctorSlotsData = [];
    this.DoctorSelectionshow = true;
    this.SelectedDoctorId = "";
    this.BranchSubSpecializationId = "";
    this.SubSpecializationId = "";
  }

  getAllDoctors(branchid, SubSpecializationId) {
    var param;

    this.ngxLoader.start();
    var AllSubSpecializationInd = 1;
    if (SubSpecializationId !== 0) {
      AllSubSpecializationInd = 0;
    }
    var obj = {
      "SubOrganizationId": this.SelectedSubOrganizationId,
      "BranchId": branchid,
      "AllSubSpecializationInd": AllSubSpecializationInd,
      "SubSpecializationId": SubSpecializationId,
      "DoctorId":0
    }


    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/getBranchDoctorsForPlugin", param, this.options).subscribe(result => {

      console.log(result);
      this.SelectedDoctorData = [];
      this.isDoctorSelected = false;
      if (result.length > 0) {
        this.SelectedDoctorData = result.filter((item) => (item.RoleId === 1 || item.RoleId === 3 || item.RoleId === 4 || item.RoleId === 43 || item.RoleId === 16 || item.RoleId === 56 || item.RoleId === 57));


        this.SelectedDoctorData.forEach((subitem, index) => {

          subitem.isDoctorSelected = false;
          subitem.newslotappointmenttype = false;
          subitem.showConsultationFee = false;
          subitem.showTeleConsultationFee = false;
          subitem.isUserProfilePicAvailable = false;
          subitem.UserProfilePicUrl = subitem.UserProfilePicUrl || "";
          if (subitem.UserProfilePicUrl !== "") {
            subitem.isUserProfilePicAvailable = true;
          }
          if (subitem.ConsultationFee !== 0) {
            subitem.showConsultationFee = true;
          }
          if (subitem.TeleConsultationFee !== 0) {
            subitem.showTeleConsultationFee = true;
          }
          subitem.doctorotherinfo = "";

          var Designation = "", DoctorSpecialization = "", Experience = "";
          if (subitem.Designation != '') {
            Designation = subitem.Designation + " ,";
          }
          if (subitem.DoctorSpecialization != '') {
            DoctorSpecialization = subitem.DoctorSpecialization + " ,";
          }
          if (subitem.Experience != '' && subitem.Experience != null && subitem.Experience != undefined) {
            Experience = subitem.Experience + ' Years Experience Overall';
          }
          subitem.doctorotherinfo = Designation + "" + DoctorSpecialization + "" + Experience;

          subitem.NextAvailableNormalSlot = "";
          subitem.NextAvailableTeleSlot = "";
          subitem.NextAvailableNormalSlot = subitem.HospitalAddress[0].NextAvailableNormalSlot || "";
          subitem.NextAvailableTeleSlot = subitem.HospitalAddress[0].NextAvailableTeleSlot || "";

          if (subitem.NextAvailableNormalSlot == "") {
            subitem.NextAvailableNormalSlot = "N/A";
          } else {
            subitem.NextAvailableNormalSlot = this.datePipe.transform(subitem.NextAvailableNormalSlot, 'dd/MM/yyyy')
          }

          if (subitem.NextAvailableTeleSlot == "") {
            subitem.NextAvailableTeleSlot = "N/A";
          } else {
            subitem.NextAvailableTeleSlot = this.datePipe.transform(subitem.NextAvailableTeleSlot, 'dd/MM/yyyy')
          }

        });


      }


      this.ngxLoader.stop();


    }, error => console.error(error));

  }

  getAllTeleDoctors(SubSplId) {
    var param;

    console.log(SubSplId);
    var AllSubSpecializationInd = 0;
    if (SubSplId == 0) {
      AllSubSpecializationInd = 1;
    }

    this.ngxLoader.start();

    var obj = {
      "SubOrganizationId": this.SelectedSubOrganizationId,
      "AllSubSpecializationInd": AllSubSpecializationInd,
      "SubSpecializationId": SubSplId
    }


    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/getTeleDoctorsById", param, this.options).subscribe(result => {

      console.log(result);
      this.SelectedDoctorData = [];
      this.isDoctorSelected = false;
      if (result.length > 0) {
        this.SelectedDoctorData = result.filter((item) => (item.RoleId === 1 || item.RoleId === 3 || item.RoleId === 4 || item.RoleId === 43 || item.RoleId === 16 || item.RoleId === 56 || item.RoleId === 57));


        this.SelectedDoctorData.forEach((subitem, index) => {

          subitem.isDoctorSelected = false;
          subitem.newslotappointmenttype = false;
          subitem.showConsultationFee = false;
          subitem.showTeleConsultationFee = false;

          subitem.NextAvailableNormalSlot = "N/A";
          subitem.NextAvailableTeleSlot = "N/A";

          subitem.doctorotherinfo = "";
          subitem.ConsultationFee = 0;
          subitem.TeleConsultationFee = 0;

          subitem.isUserProfilePicAvailable = false;
          subitem.UserProfilePicUrl = subitem.UserProfilePicUrl || "";
          if (subitem.UserProfilePicUrl !== "") {
            subitem.isUserProfilePicAvailable = true;
          }
          var Designation = "", DoctorSpecialization = "", Experience = "";
          if (subitem.Designation != '') {
            Designation = subitem.Designation + " ,";
          }
          if (subitem.DoctorSpecialization != '') {
            DoctorSpecialization = subitem.DoctorSpecialization + " ,";
          }
          if (subitem.Experience != '' && subitem.Experience != null && subitem.Experience != undefined) {
            Experience = subitem.Experience + ' Years Experience Overall';
          }
          subitem.doctorotherinfo = Designation + "" + DoctorSpecialization + "" + Experience;


        });


      }


      this.ngxLoader.stop();


    }, error => console.error(error));

  }


  getAllSubOrgBranchesDoctors() {


    var param;

    this.ngxLoader.start();


    var obj = {
      "SubOrganizationId": this.SelectedSubOrganizationId,
      "BranchId": 0,
      "AllSubSpecializationInd": 1,
      "SubSpecializationId": 0,
      "DoctorId": this.directdoctorId
    }


    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/getBranchDoctorsForPlugin", param, this.options).subscribe(result => {

      console.log(result);
      this.SelectedDoctorData = [];
      this.isDoctorSelected = false;
      if (result.length > 0) {
        this.SelectedDoctorData = result.filter((item) => (item.RoleId === 1 || item.RoleId === 3 || item.RoleId === 4 || item.RoleId === 43 || item.RoleId === 16 || item.RoleId === 56 || item.RoleId === 57));


        this.SelectedDoctorData.forEach((subitem, index) => {

          subitem.isDoctorSelected = false;
          subitem.newslotappointmenttype = false;
          subitem.showConsultationFee = false;
          subitem.showTeleConsultationFee = false;

          subitem.NextAvailableNormalSlot = "N/A";
          subitem.NextAvailableTeleSlot = "N/A";

          subitem.doctorotherinfo = "";
          subitem.ConsultationFee = 0;
          subitem.TeleConsultationFee = 0;

          subitem.isUserProfilePicAvailable = false;
          subitem.UserProfilePicUrl = subitem.UserProfilePicUrl || "";
          if (subitem.UserProfilePicUrl !== "") {
            subitem.isUserProfilePicAvailable = true;
          }
          var Designation = "", DoctorSpecialization = "", Experience = "";
          if (subitem.Designation != '') {
            Designation = subitem.Designation + " ,";
          }
          if (subitem.DoctorSpecialization != '') {
            DoctorSpecialization = subitem.DoctorSpecialization + " ,";
          }
          if (subitem.Experience != '' && subitem.Experience != null && subitem.Experience != undefined) {
            Experience = subitem.Experience + ' Years Experience Overall';
          }
          subitem.doctorotherinfo = Designation + "" + DoctorSpecialization + "" + Experience;


        });


        if (this.SelectedDoctorData.length === 1 && this.directdoctorId !==0) {
          this.onDoctorSelected(this.SelectedDoctorData[0],0);
        }
      }


      this.ngxLoader.stop();


    }, error => console.error(error));

  }

  onDoctorSelected(doctor, ind): void {

    console.log(this.slotappointmenttype.value);
    this.SelectedDoctor = doctor;
    this.SelectedDoctorId = doctor.DoctorID;
    if (this.slotappointmenttype.value == "1") {
      this.showTeleType = "2";
      this.ngxLoader.start();

      this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/getWorkingBranchesByDoctorId?DoctorId=' + doctor.DoctorID).subscribe(result => {

        console.log(result);
        this.WorkingBranchsList = [];
        doctor.newslotappointmenttype = false;
        if (result.status == "Success") {
          doctor.newslotappointmenttype = true;
          this.WorkingBranchsList = result.rows;



          this.newSelectedBranchId = this.WorkingBranchsList[0];
          if (this.SelectedDoctorId != 0 && this.newSelectedBranchId) {
            this.http.get<any>(this.baseUrl + '/api/MasterAdmins/GetUserSubSpecializationList?DoctorId=' + this.SelectedDoctorId + "&BranchId=" + this.newSelectedBranchId).subscribe(result => {

              if (result.status == "Success") {
                doctor.UserSubSpecialization = result.rows;
                if (doctor.UserSubSpecialization.length > 0) {
                  doctor.UserSubSpecialization.forEach((item, index) => {
                    if (item.IsPrimarySubSpecialization === true) {
                      this.BranchSubSpecializationId = item.BranchSubSpecializationId;
                      this.SubSpecializationId = item.SubSpecializationId;
                    }
                  });
                }
              }

              this.ngxLoader.stop();

            }, error => console.error(error));
          }
          
          this.selectDoctorBranch(this.newSelectedBranchId, doctor, ind,"1");
        }

        this.ngxLoader.stop();

      }, error => console.error(error));


    } else {

      this.showTeleType = "1";
      if (this.filterBranchOrDoctype.value == "0") {
       
      
        this.SelectedDate = new Date();

        var selecteduserHospitalarray = this.SelectedDoctor.HospitalAddress.filter((item) => item.HospitalID == this.SelectedHospitalId);

        
        this.SelectedDoctor.UserSubSpecialization = selecteduserHospitalarray[0].UserSubSpecialization || [];
      

        this.SelectedUserBranchId = selecteduserHospitalarray[0].UserBranchId || 0;
        this.SelectedDoctorData.forEach((item, index) => {
          item.isDoctorSelected = false;
        });
        doctor.isDoctorSelected = true;
        //if (this.SelectedDoctor.UserSubSpecialization.length > 0) {
        //  this.SelectedDoctor.UserSubSpecialization.forEach((item, index) => {
        //    if (item.IsPrimarySubSpecialization === true) {
        //      this.BranchSubSpecializationId = item.BranchSubSpecializationId;
        //      this.SubSpecializationId = item.SubSpecializationId;
        //    }
        //  });
        //}

        
        if (this.SelectedDoctorId != 0 && selecteduserHospitalarray[0].HospitalID) {
          this.http.get<any>(this.baseUrl + '/api/MasterAdmins/GetUserSubSpecializationList?DoctorId=' + this.SelectedDoctorId + "&BranchId=" + selecteduserHospitalarray[0].HospitalID).subscribe(result => {
            
            if (result.status == "Success") {
              this.SelectedDoctor.UserSubSpecialization = result.rows;
              if (this.SelectedDoctor.UserSubSpecialization.length > 0) {
               this.SelectedDoctor.UserSubSpecialization.forEach((item, index) => {
              if (item.IsPrimarySubSpecialization === true) {
              this.BranchSubSpecializationId = item.BranchSubSpecializationId;
              this.SubSpecializationId = item.SubSpecializationId;
            }
          });
        }
            }

            this.ngxLoader.stop();

          }, error => console.error(error));
        }

        this.GetSoltes();
        this.GetDoctorBookedSlots();
      } else {

        this.WorkingBranchsList = [];
       
        doctor.newslotappointmenttype = true;
       


        this.SelectedDoctor.HospitalAddress.forEach((hitem, index) => {
          var obj = {
            "BranchId": hitem.HospitalID,
            "BranchName": hitem.HospitalName,
            "UserBranchId": hitem.UserBranchId,
            "ConsultationFee": hitem.ConsultationFee,
            "TeleConsultationFee": hitem.TeleConsultationFee,
            "TeleMinPerCase": hitem.TeleMinPerCase,
            "RestrictMultipleSlotsonSameSlot": hitem.RestrictMultipleSlotsonSameSlot,
            "MinPerCase": hitem.MinPerCase,
            "IsDoctorSlotAvailable": hitem.IsDoctorSlotAvailable,
            "IsDoctorTeleSlotAvailable": hitem.IsDoctorTeleSlotAvailable,
            "NextAvailableNormalSlot": hitem.NextAvailableNormalSlot,
            "NextAvailableTeleSlot": hitem.NextAvailableTeleSlot,
            //"UserSubSpecialization": hitem.UserSubSpecialization || [],
            "UserSubSpecialization": this.SelectedDoctor.UserSubSpecialization || [],
            "Address1": hitem.Address1,
            "Address2": hitem.Address2,
            "CityId": hitem.CityId,
            "CityName": hitem.CityName,
            "StateId": hitem.StateId,
            "CountryId": hitem.CountryId,
            "CountryName": hitem.CountryName,
            "StateName": hitem.StateName,
            "PinCode": hitem.PinCode
          }

          console.log(obj);
          this.WorkingBranchsList.push(obj);
        });





          this.newSelectedBranchId = this.WorkingBranchsList[0];

          this.selectDoctorBranch(this.newSelectedBranchId, doctor, ind,'2');
        

      }

     

     
    }


  }



  BackToCity(): void {
    this.hospitalshow = true;
    this.branchSelectionshow = false;
    this.DoctorSelectionshow = false;
    this.filterBranchOrDoctype.value = "0";
    this.filtertypeInd = true;
  }
  BackToBranch(): void {
    this.DoctorSelectionshow = false;
    this.branchSelectionshow = true;
    this.branchAddressInfoshow = false;
    this.SelectedBranchInfo.MobileNo = "";
    this.SelectedBranchInfo.Email = "";
    this.SelectedBranchInfo.Address = "";
  }
  BackToDoctor(): void {
    this.OtpContactScreenshow = true;
    this.SerarchPatient.SearchContactNo = "";
    this.SerarchPatient = {
      "GeneratedOTP": "",
      "GeneratedOTP1": "",
      "GeneratedOTP2": "",
      "GeneratedOTP3": "",
      "GeneratedOTP4": "",
    };
    this.DoctorSelectionshow = true;
    this.FinalInformationshow = false;
    this.OtpAndVerifyScreenshow = true;
    this.IsPatientExits = false;
    this.filtertypeInd = true;
    this.FinalDetailScreenshow = false;
    this.showAppointmentTypeSlection = true;
    this.bookAppointment.FirstName = "";
    this.bookAppointment.LastName = "";
    this.bookAppointment.PatientDOB = "";
    this.bookAppointment.PatientGender = "";
    this.bookAppointment.PatientMobile = "";
    this.bookAppointment.PatientEmail = "";
    this.referralSourceDtls.ReferralID = 0;
    this.referralSourceDtls.SubReferralID = 0;
    clearInterval(this.interval);
    this.myform.reset();
  }


  changeslotAppointmentType(type): void {
    console.log(type);
    this.slotappointmenttypeInd = false;
    this.filtertypeInd = true;
    this.filterBranchOrDoctype.value = "0";
    if (type == "1") {
      this.slotappointmenttypeInd = true;
      this.filtertypeInd = false;
      this.filterBranchOrDoctype.value = "1";
      this.hospitalshow = false;
      this.branchSelectionshow = false;
      this.branchAddressInfoshow = true;
      this.chunkedData = [];
      this.SelectedDoctorId = "";
      this.HospitalDoctorSlotsData = [];
      this.DoctorSelectionshow = true;
      this.SelectedDoctorId = "";
      this.BranchSubSpecializationId = "";
      this.SubSpecializationId = "";
      this.getAllTeleDoctors(0);
      this.getSubOrgSpecializations();
    }
    else {
      this.branchAddressInfoshow = false;
      this.DoctorSelectionshow = false;
      this.hospitalshow = true;
      this.branchSelectionshow = false;


      this.DoctorSelectionshow = false;
      this.FinalInformationshow = false;
      this.OtpAndVerifyScreenshow = true;
      this.IsPatientExits = false;
      this.FinalDetailScreenshow = false;
    }
  }


  changeFilterType(type): void {
    console.log(type);
    if (type == "1") {
      this.hospitalshow = false;
      this.branchSelectionshow = false;
      this.branchAddressInfoshow = true;
      this.chunkedData = [];
      this.SelectedDoctorId = "";
      this.HospitalDoctorSlotsData = [];
      this.DoctorSelectionshow = true;
      this.SelectedDoctorId = "";
      this.BranchSubSpecializationId = "";
      this.SubSpecializationId = "";
      this.getAllSubOrgBranchesDoctors();
      this.getSubOrgSpecializations();
    }
    else {
      this.branchAddressInfoshow = false;
      this.DoctorSelectionshow = false;
      this.hospitalshow = true;
      this.branchSelectionshow = false;
      this.DoctorSelectionshow = false;
      this.FinalInformationshow = false;
      this.OtpAndVerifyScreenshow = true;
      this.IsPatientExits = false;
      this.FinalDetailScreenshow = false;
    }
  }

  BackToPatientSelection(): void {
    this.FinalInformationshow = true;
    this.CovidQuetionss = false;
    this.withOutDocFinalConfirmation = false;
  }
  ChangeCalenderDate(Date: any, index: number): void {
    this.filterindex = index;
    this.SelectedDate = Date;

    this.GetDoctorBookedSlots()

  }

  onChangeCity(City: any): void {
    this.hospitalshow = false;
    this.SelectedCity = City;
    this.HospitalFilterLIst = this.HospitalDoctorData.filter((item) => item.HospitalInfo.HospitalAddress.CityName == City);



    console.log(this.HospitalFilterLIst);
    this.HospitalFilterLIst.forEach((hitem, index) => {


      if (hitem.HospitalInfo.HospitalAddress.CityName === City) {
        this.searchDoctorsObj.CityId = hitem.HospitalInfo.HospitalAddress.CityId;
      }


      hitem.fullAddress = "";
      hitem.fullAddress = hitem.HospitalInfo.HospitalAddress.Address1 + ", " + hitem.HospitalInfo.HospitalAddress.Address2 + ", " + hitem.HospitalInfo.HospitalAddress.Location + ", " + hitem.HospitalInfo.HospitalAddress.CityName + ", " + hitem.HospitalInfo.HospitalAddress.StateName + ", " + hitem.HospitalInfo.HospitalAddress.CountryName + ", " + hitem.HospitalInfo.HospitalAddress.PinCode
    });
    this.branchSelectionshow = true;

    if (this.HospitalFilterLIst.length === 1) {

      var branchobj = this.HospitalFilterLIst[0];
      this.onHospitalSelected(branchobj)
    }
  }


  changeCityDropDown(item) {

    console.log(item);
    var selectedCityObj = this.NewCityArrayList.filter((citem) => citem.CityId == item.CityId)[0];


    this.SelectedCity = selectedCityObj.CityName;
    this.HospitalFilterLIst = this.HospitalDoctorData.filter((item) => item.HospitalInfo.HospitalAddress.CityName == this.SelectedCity);
    this.HospitalFilterLIst.forEach((hitem, index) => {


      if (hitem.HospitalInfo.HospitalAddress.CityName === this.SelectedCity) {
        this.searchDoctorsObj.CityId = hitem.HospitalInfo.HospitalAddress.CityId;
      }


      hitem.fullAddress = "";
      hitem.fullAddress = hitem.HospitalInfo.HospitalAddress.Address1 + ", " + hitem.HospitalInfo.HospitalAddress.Address2 + ", " + hitem.HospitalInfo.HospitalAddress.Location + ", " + hitem.HospitalInfo.HospitalAddress.CityName + ", " + hitem.HospitalInfo.HospitalAddress.StateName + ", " + hitem.HospitalInfo.HospitalAddress.CountryName + ", " + hitem.HospitalInfo.HospitalAddress.PinCode
    });
    this.BranchSubSpecializationList = [];
    this.SelectedDoctorData = [];
  }

  changeBranchDropDown(item) {

    console.log(item);



    this.SelectedHospitalId = item.BranchId;
    this.searchDoctorsObj.BranchId = item.BranchId;
    var selectedSpecilationobj = this.HospitalDoctorData.filter((hitem) => hitem.HospitalInfo.HospitalDetails.HospitalID == item.BranchId)[0];
    console.log(selectedSpecilationobj);
    this.BranchSubSpecializationList = [];
    this.BranchSubSpecializationList = selectedSpecilationobj.BranchSubSpecialization;

    var allBranchSpecializationObj = {
      "BranchSubSpecializationId": 0,
      "SpecializationId": 0,
      "SubSpecializationId": 0,
      "SubSpecializationName": "All Specializations"
    };
    this.searchDoctorsObj.SubSpecializationId = 0;
    this.searchDoctorsObj.AllSubSpecializationInd = 1;
    this.BranchSubSpecializationList.unshift(allBranchSpecializationObj);
    this.getAllDoctors(this.SelectedHospitalId, this.searchDoctorsObj.SubSpecializationId);
  }

  changeSubSpecializationDropDown(item) {

    if (this.slotappointmenttype.value == '1') {
      this.getAllTeleDoctors(item.SubSpecializationId)
    } else {
      this.getAllDoctors(this.SelectedHospitalId, item.SubSpecializationId);
    }

  }

  ngOnInit() {
    this.baseUrl = environment.baseUrl;
    this.minDate = new Date();
    this.maxDate = new Date();
    this.currentdate = new Date();
    const queryParams = this.activeRoute.snapshot.queryParams;

    console.log(queryParams);
    const routeParams = this.activeRoute.snapshot.params;

    console.log(routeParams);
    this.createFormControls();
    this.createForm();
    this.SelectedDate = "";
    this.bookAppointment = new BookAppointment();
    this.productinfo = new Productinfo();
    console.log(JSON.stringify(this.bookAppointment));
    this.hospitalDetails = new HospitalDetails();
    this.referralSourceDtls = new ReferralSourceDtls();
    this.searchDoctorsObj = new searchDoctorsObj();
    this.searchDoctorsObj.BranchId = 0;
    this.searchDoctorsObj.CityId = 0;
    this.communicationDetails = new CommunicationDetails();
    this.ngxLoader.start();
    this.branchLoggedinId = routeParams.id;
    this.showAppointmentTypeSlection = true;

    console.log(this.branchLoggedinId);
    //routeParams.id = routeParams.id || 3;

    this.bookAppointment.RedirectUrl = window.location.href;

    //this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/GetDoctors?HospitalID=' + routeParams.id).subscribe(result => {
    this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/GetDoctorsByOrganizationCode?OrganizationCode=' + routeParams.id).subscribe(result => {
      this.HospitalDoctorData = result;
      //var unqList = this.HospitalDoctorData.map(item => $filter("date")(new Date(item.CreatedDate), "dd-MMM-yyyy HH:mm"))
      //  .filter((value, index, self) => self.indexOf(value) === index);
      this.CityArrayList = this.HospitalDoctorData.map(item => item.HospitalInfo.HospitalAddress.CityName)
        .filter((value, index, self) => self.indexOf(value) === index);
      console.log(this.CityArrayList);





      this.NewCityArrayList = [];
      this.HospitalDoctorData.forEach((hitem, index) => {
        var obj = {
          "CityId": hitem.HospitalInfo.HospitalAddress.CityId,
          "CityName": hitem.HospitalInfo.HospitalAddress.CityName
        }
        this.NewCityArrayList.push(obj);
      });
      this.NewCityArrayList = this.NewCityArrayList.filter(
        (thing, i, arr) => arr.findIndex(t => t.CityId === thing.CityId) === i
      );
      console.log(this.NewCityArrayList);

      this.ParentHospitalDetails = this.HospitalDoctorData.filter((item) => item.HospitalInfo.HospitalDetails.OrganizationCode == routeParams.id)[0];

      if (this.ParentHospitalDetails) {
        console.log(this.ParentHospitalDetails.HospitalInfo);
        this.SelectedParentHospitalId = this.ParentHospitalDetails.HospitalInfo.HospitalDetails.ParentOrganizationId;
        this.SelectedSubOrganizationId = this.ParentHospitalDetails.HospitalInfo.HospitalDetails.SubOrganizationId;
      }
      let index = this.HospitalDoctorData.findIndex((item) => item.HospitalInfo.HospitalDetails.OrganizationCode == routeParams.id);
      this.CountryID = this.HospitalDoctorData[index].HospitalInfo.HospitalAddress.CountryId;
      this.CountryCode = this.HospitalDoctorData[index].HospitalInfo.HospitalAddress.InternationalDialing;
      console.log("CountryID", this.CountryID);
      this.HospitalFilterLIst = this.HospitalDoctorData;
      //this.HospitalFilterLIst = this.HospitalDoctorData.filter((item) => item.HospitalInfo.HospitalAddress.CityName == this.SelectedCity);
      this.ngxLoader.stop();
      var param;
      var obj = {
        // "ParentOrganizationId": routeParams.id
        "ParentOrganizationId": this.SelectedParentHospitalId


      }
      param = JSON.stringify(obj);
      param = "'" + param + "'";

      this.http.post<any>(this.baseUrl + "/api/Setting/GetOrganizationSettings", param, this.options).subscribe(result => {
        console.log(JSON.stringify(result));
        this.ngxLoader.stop();
        this.OrganizationSettingsData = result.SettingDetails;


      }, error => console.error(error));

      var param1;

      var obj1 = { "SubOrganizationId": this.SelectedSubOrganizationId, "BranchId": 0 };
      param1 = JSON.stringify(obj1);
      param1 = "'" + param1 + "'";

      this.http.post<any>(this.baseUrl + "/api/Setting/GetPrintSettings", param1, this.options).subscribe(result => {
        console.log(JSON.stringify(result));
        this.ngxLoader.stop();
        this.PrintOrganizationSettingsData = result.data;
        this.PrintOrganizationSettingsData.PrintHeaderImgUrl = this.PrintOrganizationSettingsData.PrintHeaderImgUrl || "";
        this.PrintOrganizationSettingsData.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
        this.PrintOrganizationSettingsData.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
        this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";

      }, error => console.error(error));


      console.log(routeParams.value);

    
    
      var routeplen = routeParams.value.length;

       //Doctor selection direct code added by durga as on 02-07-2021
      if (routeplen === 1) {

        if (routeParams.value === '1') {
          this.slotappointmenttype.value = '1';
          this.filterBranchOrDoctype.value = "1";
          this.slotappointmenttypeInd = true;
          this.filtertypeInd = false;
          this.hospitalshow = false;
          this.branchSelectionshow = false;
          this.branchAddressInfoshow = true;
          this.chunkedData = [];
          this.SelectedDoctorId = "";
          this.HospitalDoctorSlotsData = [];
          this.DoctorSelectionshow = true;
          this.SelectedDoctorId = "";
          this.BranchSubSpecializationId = "";
          this.SubSpecializationId = "";
          this.getAllTeleDoctors(0);
          this.getSubOrgSpecializations();
        }
        if (routeParams.value === '0') {
          this.slotappointmenttype.value = '0';
          this.filterBranchOrDoctype.value = "0";
          this.slotappointmenttypeInd = false;
          this.filtertypeInd = true;
        }
      } else {

        
        var routevalArray = routeParams.value.split("_");
        console.log(routevalArray[0]);
        console.log(routevalArray[1]);

        var onroadUserId = 0;

        onroadUserId = routevalArray[1];

        this.slotappointmenttype.value = '0';
        this.filterBranchOrDoctype.value = "1";
        this.slotappointmenttypeInd = false;
        this.filtertypeInd = true;
        this.directdoctorId = onroadUserId;
        this.changeFilterType("1");
        
      }

    
     


    }, error => console.error(error));

    this.http.get<any>(this.baseUrl + '/api/MasterData/GetCovid19Quetions').subscribe(result => {
      this.COVID19Quetions = result;
      this.FinalCovidQuestionArray = [];
      this.COVID19Quetions.forEach((kitem, index) => {
        kitem.RowId = kitem.QuestionId;
        if (kitem.QuestionId === 1 || kitem.QuestionId === 2 || kitem.QuestionId === 3 || kitem.QuestionId === 5 || kitem.QuestionId === 7 || kitem.QuestionId === 8) {
          this.FinalCovidQuestionArray.push(kitem);
        }
      });
      this.FinalCovidQuestionArray = this.FinalCovidQuestionArray.sort((a, b) => b - a);
      this.ngxLoader.stop();
    }, error => console.error(error));





  }

  createFormControls() {
    this.firstName = new FormControl('', Validators.required);
    this.lastName = new FormControl('', Validators.required);
    this.datePicker = new FormControl('', Validators.required);
    this.email = new FormControl('', [
      Validators.pattern("[^ @]*@[^ @]*"),
      Validators.required
    ]); 
    //this.mobile = new FormControl('', [
    //  Validators.pattern(/^[6-9]\d{9}$/),
    //  Validators.required
    //]);
    this.mobile = new FormControl('', [
      Validators.pattern(/^[0-9]*$/),
      Validators.required
    ]);
    this.gender = new FormControl('', Validators.required);
  }

  createForm() {
    this.myform = new FormGroup({
      firstName: this.firstName,
      lastName: this.lastName,
      mobile: this.mobile,
      gender: this.gender,
      email: this.email,
      datePicker: this.datePicker
    });


  }
  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }

  BookSlots(Item: any, type: boolean): void {

    this.DoctorSelectionshow = false;
    this.SlectedSlots = Item;
    this.filtertypeInd = false;
    this.FinalInformationshow = true;
    this.showAppointmentTypeSlection = false;
    this.IsTeleSlot = type;
    this.avgConsultationTime = this.SlectedSlots.MinPerCase;
    console.log(Item);
    console.log(this.SlectedSlots);





  }


  ContinueToBookAppointment() {

    if (this.bookAppointment.FirstName === '' || this.bookAppointment.FirstName === undefined) {
      this.toastr.error("Please Select a Patient");
      return false;
    }

    this.FinalInformationshow = false;
    this.CovidQuetionss = true;

    this.userfreeFollowUp = false;//we have to get from UserSettingObject in Seetings FreeFollowup or not
    if (this.OrganizationSettingsData !== undefined) {
      if (this.OrganizationSettingsData.AppointmentSettings !== undefined) {
        if (this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline !== undefined) {
          this.userfreeFollowUp = this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline == 1 ? true : false;
        }
      }
    }


    this.appointmentType = "4";
    console.log(this.userfreeFollowUp);
    if (this.userfreeFollowUp) {
      var param = {
        "PatientId": this.bookAppointment.PatientID,
        "AppointmentDate": this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'),
        "UserBranchId": this.SelectedUserBranchId,
        "Type": this.IsTeleSlot ? 'Tele' : 'Normal',
        "DoctorID": this.SelectedDoctorId
      }
      this.ngxLoader.start();

      var params = JSON.stringify(param);
      params = "'" + params + "'";
      this.isPaidSlot = false;
      this.http.post<any>(this.baseUrl + "/api/MasterPatient/getParticularSlotInfo", params, this.options).subscribe(result => {
        console.log(JSON.stringify(result));
        this.ngxLoader.stop();

        if (result.status === 'Success') {
          this.isPaidSlot = result.IsPaidSlot;
          
          if (this.isPaidSlot) {
            this.appointmentType = "4";
          } else {
            this.appointmentType = "3";
          }
          this.walkinConsultationFee = parseFloat(result.walkinConsultationFee) || 0;
          this.teleConsultationFee = parseFloat(result.teleConsultationFee) || 0;
          this.walkinCommissionFee = parseFloat(result.walkinCommissionFee) || 0;
          this.teleCommissionFee = parseFloat(result.teleCommissionFee) || 0;
          this.walkinCommissionwithGst = parseFloat(result.walkinCommissionwithGst) || 0;
          this.teleCommissionWithGst = parseFloat(result.teleCommissionWithGst) || 0;
          this.gstPercentage = parseFloat(result.gstPercentage) || 0;
          this.ChildMerchantId = result.ChildMerchantId;

          if (this.IsTeleSlot) {
            if (result.IsCommisionIncluded) {
              this.consultationFee = this.teleConsultationFee - this.teleCommissionFee;
            } else {
              this.consultationFee = this.teleConsultationFee;
            }
            this.additionalCharges = this.teleCommissionFee;


          }
          else {
            if (result.IsCommisionIncluded) {
              this.consultationFee = this.walkinConsultationFee - this.walkinCommissionFee;
            } else {
              this.consultationFee = this.walkinConsultationFee
            }
            this.additionalCharges = this.walkinCommissionFee;
          }


          var totalAmount = this.consultationFee + this.additionalCharges;
          var number = totalAmount.toFixed(2);
          this.totalAmount = parseFloat(number);
          console.log(this.consultationFee);
          console.log(this.additionalCharges);
          console.log(this.totalAmount);


          if (this.IsTeleSlot) {
            this.CovidQuetionss = false;

            if (this.isPaidSlot) {
              this.navPayBookAppointment();
            } else {
              this.BookAppointment();
            }
          }
        }
      }, error => console.error(error));

    } else {
      if (!this.isPaidSlot) {
        this.isPaidSlot = false;
      }

      if (this.IsTeleSlot) {
        this.CovidQuetionss = false;

        if (this.isPaidSlot) {
          this.navPayBookAppointment();
        } else {
          this.BookAppointment();
        }
      }
    }



  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  ChangeMobileNumber() {
    this.FinalInformationshow = true;
    this.OtpContactScreenshow = true;
    this.OtpAndVerifyScreenshow = true;
    this.SerarchPatient.SearchContactNo = "";
    this.SerarchPatient.GeneratedOTP = "";
    this.SerarchPatient.GeneratedOTP1 = "";
    this.SerarchPatient.GeneratedOTP2 = "";
    this.SerarchPatient.GeneratedOTP3 = "";
    this.SerarchPatient.GeneratedOTP4 = "";

  }

  GetSoltes() {
    var param;
    var datePipe = new DatePipe('en-US');
    var obj = {
      "Available": "Y",
      "startDate": datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'),
      "endDate": datePipe.transform(this.selectedFromDate, 'yyyy-MM-dd'),
      "UserBranchId": this.SelectedUserBranchId,
      "HospitalId": this.SelectedHospitalId,
      "DoctorID": this.SelectedDoctorId
    }
    this.ngxLoader.start();
    console.log(JSON.stringify(obj));
    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/GetDoctorAvailableslots", param, this.options).subscribe(result => {
      this.HospitalDoctorSlotsData = result;


      console.log(JSON.stringify(this.HospitalDoctorSlotsData));
      this.ngxLoader.stop();

      this.HospitalDoctorSlotsData.calendarList.forEach((item, index) => {
        item.NormalSlots = [];
        item.TeleSlots = [];
        item.SlotLst = item.SlotLst || [];
        item.SlotLst.forEach((subitem, index) => {
          subitem.SlotLst.forEach((slotitem, index) => {
            item.NormalSlots.push(slotitem);
          });

        });


        item.TeleSlotLst = item.TeleSlotLst || [];
        item.TeleSlotLst.forEach((subitem, index) => {
          subitem.SlotLst.forEach((slotitem, index) => {
            item.TeleSlots.push(slotitem);
          });

        });
      });


      //if (this.HospitalDoctorSlotsData.calendarList[this.filterindex].SlotLst != undefined) {
      //  let FormatDate = new Date();
      //  if (datePipe.transform(this.SelectedDate, 'yyyy-MM-dd') === datePipe.transform(FormatDate, 'yyyy-MM-dd')) {
      //    let filterSequence = this.datePipe.transform(FormatDate, 'HHmm');
      //    this.HospitalDoctorSlotsData.calendarList[this.filterindex].NormalSlots = this.HospitalDoctorSlotsData.calendarList[this.filterindex].NormalSlots.filter((item) => parseInt(item.Sequence) >= parseInt(filterSequence));

      //  }
      //}

      //if (this.HospitalDoctorSlotsData.calendarList[this.filterindex].TeleSlotLst != undefined) {
      //  let FormatDate = new Date();

      //  if (datePipe.transform(this.SelectedDate, 'yyyy-MM-dd') === datePipe.transform(FormatDate, 'yyyy-MM-dd')) {
      //    let filterSequence = this.datePipe.transform(FormatDate, 'HHmm');
      //    this.HospitalDoctorSlotsData.calendarList[this.filterindex].TeleSlots = this.HospitalDoctorSlotsData.calendarList[this.filterindex].TeleSlots.filter((item) => parseInt(item.Sequence) >= parseInt(filterSequence));
      //  }

      //}

      //console.log(this.HospitalDoctorSlotsData.calendarList[this.filterindex].NormalSlots);
      //console.log(this.HospitalDoctorSlotsData.calendarList[this.filterindex].TeleSlots);

      //this.globalService.setData(this.HospitalDoctorSlotsData);
      //this.globalService.setHospitalInfo(this.SelectedHospital);
      //this.globalService.setDoctorInfo(this.SelectedDoctor);
      //if (this.HospitalDoctorSlotsData.calendarList[0].SlotLst != undefined) {
      //  this.router.navigate(['/Slots']);
      //} else {
      //  this.errorMessage = "There is no slots For These Doctor And that time";
      //}

      //$("#Tabindex1").css("background-color", "#e5e5e5"); 

      //setTimeout(() => {
      //  $("#Tabindex1").focus();
      //  $("#Tabindex1").css("background-color", "#fff");
      //}, 100);

      //setTimeout(() => {
      //  let el = this.myElement.nativeElement.querySelector('#Tabindex1');
      //  el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      //  //el.scrollTop();
      //}, 100);


    }, error => console.error(error));

  }


  restructreDoctorSlots() {
    var datePipe = new DatePipe('en-US');



    this.doctorBookedSlots.NormalSlots.forEach((subitem, index) => {
      subitem.StartTime = subitem.StartTime.substring(0, 5);
    });
    this.doctorBookedSlots.TeleSlots.forEach((subitem, index) => {
      subitem.StartTime = subitem.StartTime.substring(0, 5);
    });

    this.normalConsultationSlots = [];
    this.teleConsultationSlots = [];

    this.doctorBookedSlots.UserConsultation.forEach((item, index) => {
      var arr = item.StartTime.split(':');
      var shour = $.trim(arr[0]);
      var smin = $.trim(arr[1]);
      if (item.MinPerCase===0) {
        item.MinPerCase = 5;
      }
     

      var arr2 = item.EndTime.split(':')
      var ehour = $.trim(arr2[0]);
      var emin = $.trim(arr2[1]);
      var startingTime = moment().hours(shour).minutes(smin);
      var endingTime = moment().hours(ehour).minutes(emin);



      var currentStartTime = startingTime;
      var token = 1;
      while (currentStartTime < endingTime) {

        var slotObj = {
          "StartTime": currentStartTime.format("HH:mm"),
          "Sequence": currentStartTime.format("HHmm"),
          "EndTime": currentStartTime.add(item.MinPerCase, "minute").format("HH:mm"),
          "TokenNumber": token,
          "MinPerCase": item.MinPerCase,
          "Available": "Y"
        }
        token++;
        this.normalConsultationSlots.push(slotObj);
      }
    });


    this.doctorBookedSlots.UserTeleConsultation.forEach((item, index) => {
      var arr = item.StartTime.split(':');
      var shour = $.trim(arr[0]);
      var smin = $.trim(arr[1]);
      if (item.MinPerCase === 0) {
        item.MinPerCase = 5;
      }

      var arr2 = item.EndTime.split(':')
      var ehour = $.trim(arr2[0]);
      var emin = $.trim(arr2[1]);
      var startingTime = moment().hours(shour).minutes(smin);
      var endingTime = moment().hours(ehour).minutes(emin);



      var currentStartTime = startingTime;
      var token = 1;
      while (currentStartTime < endingTime) {

        var slotObj = {
          "StartTime": currentStartTime.format("HH:mm"),
          "Sequence": currentStartTime.format("HHmm"),
          "EndTime": currentStartTime.add(item.MinPerCase, "minute").format("HH:mm"),
          "TokenNumber": token,
          "MinPerCase": item.MinPerCase,
          "Available": "Y"
        }
        token++;
        this.teleConsultationSlots.push(slotObj);
      }
    });


    if (this.normalConsultationSlots.length > 0) {
      let FormatDate = new Date();
      if (datePipe.transform(this.SelectedDate, 'yyyy-MM-dd') === datePipe.transform(FormatDate, 'yyyy-MM-dd')) {
        let filterSequence = this.datePipe.transform(FormatDate, 'HHmm');

        console.log(this.normalConsultationSlots);
        console.log(filterSequence);
        this.normalConsultationSlots = this.normalConsultationSlots.filter((item) => parseInt(item.Sequence) > parseInt(filterSequence));

        //For Removig already Booked Normal slots added by Durga 
        this.doctorBookedSlots.NormalSlots.forEach((item, index) => {
          for (var i = this.normalConsultationSlots.length - 1; i >= 0; i--) {
            if (item.StartTime === this.normalConsultationSlots[i].StartTime) {
              this.normalConsultationSlots.splice(i, 1);
            }
          }
        });

        console.log(this.normalConsultationSlots);
      }



    }

    if (this.teleConsultationSlots.length > 0) {
      let FormatDate = new Date();
      if (datePipe.transform(this.SelectedDate, 'yyyy-MM-dd') === datePipe.transform(FormatDate, 'yyyy-MM-dd')) {
        let filterSequence = this.datePipe.transform(FormatDate, 'HHmm');
        this.teleConsultationSlots = this.teleConsultationSlots.filter((item) => parseInt(item.Sequence) > parseInt(filterSequence));

      }
      //this.teleConsultationSlots.forEach((item, index) => {
      //  for (var i = this.doctorBookedSlots.TeleSlots.length - 1; i >= 0; i--) {
      //    if (item.StartTime === this.doctorBookedSlots.TeleSlots[i].StartTime) {
      //      this.teleConsultationSlots.splice(index, 1);
      //    }
      //  }
      //});

      //For Removig already Booked Tele slots added by Durga 
      this.doctorBookedSlots.TeleSlots.forEach((item, index) => {
        for (var i = this.teleConsultationSlots.length - 1; i >= 0; i--) {
          if (item.StartTime === this.teleConsultationSlots[i].StartTime) {
            this.teleConsultationSlots.splice(i, 1);
          }
        }
      });

    }

    console.log(this.normalConsultationSlots);
    console.log(this.teleConsultationSlots);

  }


  otpController(el) {
    if (el == 'otp2') {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        this.searchElement1.nativeElement.focus();
      }, 0);
    } else if (el == 'otp3') {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        this.searchElement2.nativeElement.focus();
      }, 0);
    } else if (el == 'otp4') {
      setTimeout(() => { // this will make the execution after the above boolean has changed
        this.searchElement3.nativeElement.focus();
      }, 0);
    }
  }




  GetDoctorBookedSlots() {
    var param;
    var datePipe = new DatePipe('en-US');
    var obj = {
      "Date": datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'),
      "UserBranchId": this.SelectedUserBranchId,
      "DoctorId": this.SelectedDoctorId
    }

    this.ngxLoader.start();

    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/Patient/GetDoctorBookedslots", param, this.options).subscribe(result => {
      this.doctorBookedSlots = result;
      console.log(result);
      this.ngxLoader.stop();


      this.restructreDoctorSlots()






    }, error => console.error(error));
  }



  LeftNav(): void {
    var dt = new Date(this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'));
    this.SelectedDate = dt.setDate(dt.getDate() - 1);
    var dt1 = new Date(this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'));
    this.selectedFromDate = dt1.setDate(dt1.getDate() + 2);
    this.GetSoltes();
    this.GetDoctorBookedSlots();
  }
  RightNav(): void {
    var dt = new Date(this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'));
    this.SelectedDate = dt.setDate(dt.getDate() + 1);
    var dt1 = new Date(this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'));
    this.selectedFromDate = dt1.setDate(dt1.getDate() + 2);
    this.GetSoltes();
    this.GetDoctorBookedSlots();
  }

  stopCountdown() {
    this.SerarchPatient.SearchContactNo = "";
    this.SerarchPatient.GeneratedOTP = "";
    this.DoctorSelectionshow = true;
    this.FinalInformationshow = false;
    this.OtpAndVerifyScreenshow = true;
    this.IsPatientExits = false;
    this.FinalDetailScreenshow = false;
    clearInterval(this.interval);
  }
  startTimer(duration) {
    var timer = duration || 0;
    var minutes, seconds;
    this.interval = setInterval(() => {
      var abc = (timer / 60).toString();
      var klm = (timer % 60).toString();
      minutes = parseInt(abc, 10);
      seconds = parseInt(klm, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      this.displayTimer = minutes + ":" + seconds;

      if (--timer < 0) {
        timer = duration;
        this.ResendotpButton = true;
        this.stopCountdown();
      }
    }, 1000)
  }


  ChangeMobile(SearchContactNo) {
    clearInterval(this.interval);
    this.SerarchPatient.GeneratedOTP = "";
    this.SerarchPatient.GeneratedOTP1 = "";
    this.SerarchPatient.GeneratedOTP2 = "";
    this.SerarchPatient.GeneratedOTP3 = "";
    this.SerarchPatient.GeneratedOTP4 = "";
    if (SearchContactNo.length >= 10) {
      this.ngxLoader.start();

      //this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/GenerateOtpForPatientAppointment?MobileNumber=' + SearchContactNo).subscribe(result => {

      this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/GenerateOtpForPatientAppointment?MobileNumber=' + SearchContactNo + "&HospitalId=" + this.SelectedParentHospitalId).subscribe(result => {
        this.OtpContactScreenshow = false;
        this.ngxLoader.stop();
        this.startTimer(60 * 10);
      }, error =>
        console.error(error));
      this.ngxLoader.stop();
    } else {
      this.toastr.error("Please enter a valid mobile number");
    }

  }
  ValidateOtp(otp1, otp2, otp3, otp4) {
    //console.log(otp);
    console.log(this.SerarchPatient.GeneratedOTP);
    this.ResendotpButton = false;

    this.bookAppointment.PatientID = 0;
    this.bookAppointment.MasterPatientId = 0;
    this.bookAppointment.FirstName = "";
    this.bookAppointment.LastName = "";
    this.bookAppointment.PatientMobile = "";
    this.bookAppointment.PatientEmail = "";
    this.bookAppointment.PatientDOB = "";
    this.bookAppointment.PatientGender = "";
    //this.bookAppointment.ReferralSourceId = 0;
    this.referralSourceDtls.ReferralID = 0;
    this.referralSourceDtls.SubReferralID = 0;
    this.SerarchPatient.GeneratedOTP = otp1 + "" + otp2 + "" + otp3 + "" + otp4;
    if (this.SerarchPatient.GeneratedOTP.length === 4) {
      this.ngxLoader.start();

      this.http.get<any>(this.baseUrl + '/api/AppointmentPlugin/ValidatePatientAppointmentOTP?MobileNumber=' + this.SerarchPatient.SearchContactNo + "&OTP=" + this.SerarchPatient.GeneratedOTP + "&HospitalId=" + this.SelectedParentHospitalId).subscribe(result => {
        console.log(result);
        if (result.status == "Success") {
          this.IsPatientExits = result.IsPatientExists;
          this.bookAppointment.PatientMobile = this.SerarchPatient.SearchContactNo;

          this.FinalDetailScreenshow = true;
          this.OtpAndVerifyScreenshow = false;
          if (result.IsPatientExists) { //Modified By Durga Directly Getting Patient in this Service instead calling another service
            this.ExistingPatientList = result.rows;


            this.ExistingPatientList.forEach((nitem) => {
              nitem.isMrnoAvailable = true;
              //if (nitem.PatientDisplayId === '') {
              //  nitem.isMrnoAvailable = false;
              //}
            });
            this.ngxLoader.stop();
            clearInterval(this.interval);

          }

        }
        if (result.status == "Failure") {
          this.toastr.error("Invalid Otp");
          this.ResendotpButton = true;
          this.SerarchPatient.GeneratedOTP = "";
          this.SerarchPatient.GeneratedOTP1 = "";
          this.SerarchPatient.GeneratedOTP2 = "";
          this.SerarchPatient.GeneratedOTP3 = "";
          this.SerarchPatient.GeneratedOTP4 = "";
        }
        this.ngxLoader.stop();

        //this.stopCountdown();
      }, error =>
        console.error(error));
      this.ngxLoader.stop();
    } else {
      this.toastr.error("Please enter a valid otp");
      this.SerarchPatient.GeneratedOTP = "";
      this.SerarchPatient.GeneratedOTP1 = "";
      this.SerarchPatient.GeneratedOTP2 = "";
      this.SerarchPatient.GeneratedOTP3 = "";
      this.SerarchPatient.GeneratedOTP4 = "";
    }


  }
  SelectPatient(item) {
    this.bookAppointment.PatientID = item.PatientId;
    this.bookAppointment.MasterPatientId = item.MasterPatientId;
    this.bookAppointment.FirstName = item.FirstName;
    this.bookAppointment.LastName = item.LastName;
    this.bookAppointment.PatientMobile = item.phnumber;
    this.bookAppointment.PatientEmail = item.EmailId || "";
    this.bookAppointment.PatientDOB = item.DOB;
    this.bookAppointment.PatientGender = item.Gender;
    this.referralSourceDtls.ReferralID = item.ReferralSourceId;
    this.referralSourceDtls.SubReferralID = item.SubReferralID;
    console.log(this.doctorNotSelected);
    this.bookAppointment.AppointmentPatientTypeId = 1;
    if (item.isMrnoAvailable) {
      this.bookAppointment.AppointmentPatientTypeId = 2;
    }

    if (!this.doctorNotSelected) {
      this.ContinueToBookAppointment();
    }


    //this.bookAppointment.PatientID = item.Patient[0].PatientId;
    //this.bookAppointment.MasterPatientId = item.MasterPatientId;
    //this.bookAppointment.FirstName = item.FirstName;
    //this.bookAppointment.LastName = item.LastName;
    //this.bookAppointment.PatientMobile = item.MobileNo;
    //this.bookAppointment.PatientEmail = item.EmailId || "";
    //this.bookAppointment.PatientDOB = item.DOB;
    //this.bookAppointment.PatientGender = item.Gender;
  }
  SelectPatientSource(event) {
    console.log(event);
    const value = event.target.value;
    this.referralSourceDtls.SubReferralID = parseInt(value);
    //console.log(value);
    //var id = this.referralSourceDtls.ReferralID;
    var obj = {
      "DoctorID": this.SelectedDoctorId,
      "USRType": "DOCTOR",
      "PageSize": 1000,
      "SearchText": "",
      "PageNumber": 1,
      "USRId": this.SelectedDoctorId,
      "MasterReferralSourceId": this.referralSourceDtls.SubReferralID,
      "OrganizationId": this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID
    }
    this.ngxLoader.start();

    var param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/Patient/GetReferralSource", param, this.options).subscribe(result => {
      this.SubReferralSouceData = result[0].rows;
      console.log(result);
      this.ngxLoader.stop();
    }, error => console.error(error));

  }
  SelectPatientSubSource(event) {
    console.log(event);
    const value = event.target.value;
    this.referralSourceDtls.ReferralID = parseInt(value);


  }



  ShowChildQuestion(item) {
    if (item.QuestionId === 3 && item.IsActive === true) {
      // var selectedarray = filter("filter")(this.FinalCovidQuestionArray, { "QuestionId": 4 }, true) || [];
      var selectedarray = this.FinalCovidQuestionArray.filter((mitem) => mitem.QuestionId == 4);
      if (selectedarray.length === 0) {
        this.FinalCovidQuestionArray.push(this.COVID19Quetions[3]);
        this.FinalCovidQuestionArray.sort((a, b) => {
          return a.RowId - b.RowId;
        });
      }
    }
    if (item.QuestionId === 3 && item.IsActive === false) {
      for (var i = this.FinalCovidQuestionArray.length - 1; i >= 0; i--) {
        if (this.FinalCovidQuestionArray[i].QuestionId === 4) {
          this.FinalCovidQuestionArray.splice(i, 1);
        }
      }
      this.FinalCovidQuestionArray.sort((a, b) => {
        return a.RowId - b.RowId;
      });
    }

    if (item.QuestionId === 5 && item.IsActive === true) {
      // var selectedarray1 = $filter("filter")(this.FinalCovidQuestionArray, { "QuestionId": 6 }, true) || [];
      var selectedarray1 = this.FinalCovidQuestionArray.filter((mitem) => mitem.QuestionId == 6);

      if (selectedarray1.length === 0) {
        this.FinalCovidQuestionArray.push(this.COVID19Quetions[5]);
        this.FinalCovidQuestionArray.sort((a, b) => {
          return a.RowId - b.RowId;
        });
      }
    }
    if (item.QuestionId === 5 && item.IsActive === false) {
      for (var i = this.FinalCovidQuestionArray.length - 1; i >= 0; i--) {
        if (this.FinalCovidQuestionArray[i].QuestionId === 6) {
          this.FinalCovidQuestionArray.splice(i, 1);
          this.FinalCovidQuestionArray.sort((a, b) => {
            return a.RowId - b.RowId;
          });
        }
      }
    }
  }



  BookAppointment() {

     var ispayment =false; 
 if (this.OrganizationSettingsData !== undefined) {
      if (this.OrganizationSettingsData.AppointmentSettings !== undefined) {
       if (this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline !== undefined) {
  ispayment  = this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline == 1 ? true : false;
  }
 }
    }


   this.bookAppointment.AppointmentID = 0;
    this.bookAppointment.ParentAppointmentId = 0;
    this.bookAppointment.RootAppointmentId = 0;
    this.bookAppointment.AppointmentStatus = 'B';
    this.bookAppointment.BookingTypeId = 2;
    //this.bookAppointment.AppointmentPatientTypeId = 1;
    this.bookAppointment.IsTeleMedicineSlot = this.IsTeleSlot;
    this.bookAppointment.IsTeleMedicineTermsAndConditions = true;


    this.bookAppointment.StartTime = this.SlectedSlots.StartTime;
    this.bookAppointment.EndTime = this.SlectedSlots.EndTime;
    this.bookAppointment.DoctorID = this.SelectedDoctor.DoctorID;
    if (this.IsTeleSlot) {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserTeleConsultation[0].DayCD;
    } else {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserConsultation[0].DayCD;
    }

    this.bookAppointment.VisitUserTypeID = this.appointmentType;
    this.bookAppointment.ConsultationDt = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.bookAppointment.UserBranchId = this.SelectedUserBranchId;
    this.bookAppointment.PatientID = this.bookAppointment.PatientID ? this.bookAppointment.PatientID : 0;

    this.bookAppointment.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.bookAppointment.UserId = this.SelectedDoctor.DoctorID;
    this.bookAppointment.USRType = "DOCTOR";
    this.bookAppointment.DoctorVisitRsnID = this.appointmentType;
    this.hospitalDetails.HospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID;

    this.hospitalDetails.ParentHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId;
    this.hospitalDetails.IsSMSInd = this.SelectedHospital.HospitalInfo.HospitalDetails.IsSMSInd;
    this.hospitalDetails.SenderId = this.SelectedHospital.HospitalInfo.HospitalDetails.SenderId;
    this.hospitalDetails.LoginHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID; //sms purpose only


    this.bookAppointment.HospitalDetails = this.hospitalDetails;

    this.referralSourceDtls.ReferralID = this.referralSourceDtls.ReferralID ? this.referralSourceDtls.ReferralID : 0;
    this.referralSourceDtls.SubReferralID = this.referralSourceDtls.SubReferralID ? this.referralSourceDtls.SubReferralID : 2;


    this.bookAppointment.ReferralSourceDtls = this.referralSourceDtls;

    this.communicationDetails.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.communicationDetails.PatientMobile = this.bookAppointment.PatientMobile;
    this.communicationDetails.DoctorMobile = this.SelectedDoctor.MobileNo;
    this.communicationDetails.DoctorName = this.SelectedDoctor.FullName;
    this.communicationDetails.AppDate = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.communicationDetails.AppTime = this.SlectedSlots.StartTime;
    this.communicationDetails.AppToken = this.SlectedSlots.TokenNumber;
    this.communicationDetails.PatientEmail = this.bookAppointment.PatientEmail;
    this.communicationDetails.DoctorEmail = this.SelectedDoctor.EmailId;
    this.communicationDetails.HospitalContact = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.communicationDetails.BrnachAddress = this.SelectedHospital.HospitalInfo.HospitalAddress;
    this.communicationDetails.CommunicationEmailId = this.SelectedDoctor.CommunicationEmailId || "";
    this.communicationDetails.CommunicationMobileNo = this.SelectedDoctor.CommunicationMobileNo || "";

    this.bookAppointment.CommunicationDetails = this.communicationDetails;
    this.bookAppointment.PreviousAppointmentDate = "";
    this.bookAppointment.IsFollowUp = false;
    this.bookAppointment.SendDocSms = true;
    this.bookAppointment.SendDocEmail = true;
    this.bookAppointment.SendPatientEmail = true;
    this.bookAppointment.SendPatientSms = true;
    this.bookAppointment.PatientTypeId = 1;
    this.bookAppointment.PatientTitle = "Mr";
    this.bookAppointment.PaidFollowup = false;
    this.bookAppointment.SubSpecializationId = this.SubSpecializationId;
    this.bookAppointment.BranchSubSpecializationId = this.BranchSubSpecializationId;
    if (this.FinalCovidQuestionArray.length > 0) {
      this.FinalCovidQuestionArray.forEach((mitem, index) => {
        this.COVID19Quetions.forEach((nitem, index) => {
          if (mitem.QuestionId === nitem.QuestionId) {
            nitem.IsActive = nitem.IsActive;
          }
        });
      });
    }
    this.bookAppointment.masterQuestions = this.COVID19Quetions;
    this.bookAppointment.consultationFee = this.consultationFee;
    this.bookAppointment.avgconsultationTime = this.avgConsultationTime;


    this.bookAppointment.PromoCodeId = this.promoCodeObj.PromoCodeId || 0;
    this.bookAppointment.PromoCode = this.promoCodeObj.promoCode || "";
    this.bookAppointment.PromoCodeAmount = this.promoCodeObj.OfferAmount || 0;

    if (this.bookAppointment.PatientID !== 0) {
      var param;
      var obj = {
        "PatientId": this.bookAppointment.PatientID,
        "AppointmentDate": this.communicationDetails.AppDate,
        "HospitalId": this.hospitalDetails.HospitalID,
        "DoctorId": this.bookAppointment.DoctorID
      };
      this.ngxLoader.start();
      console.log(JSON.stringify(obj));
      param = JSON.stringify(obj);
      param = "'" + param + "'";

      this.http.post<any>(this.baseUrl + "/api/Consultation/CheckAppointment", param, this.options).subscribe(result => {

        if (result.Status) {
          this.toastr.error("This patient has an existing appointment scheduled for the same date");
          this.ngxLoader.stop();
          return false;
        } else {
          this.ngxLoader.start();

          if (this.consultationFee === 0) {
            this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
              this.ngxLoader.stop();
              result.response.BranchId = this.branchLoggedinId;



              result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
              result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
              result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
              result.response.CountryCode = this.CountryCode || "";
              this.globalService.setAppointmentResponce(result.response);
              this.router.navigate(['/Sucess']);
            }, error => console.error(error));
          } else {
            this.PaymentConfirmationObj = new PaymentConfirmationObj();

            if (this.PaymentConfirmationObj.amount === 0 && this.promoCodeObj.OfferValueType == 'Percent') {
              this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
                this.ngxLoader.stop();
                result.response.BranchId = this.branchLoggedinId;
                result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
                result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
                result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
                result.response.CountryCode = this.CountryCode || "";
                this.globalService.setAppointmentResponce(result.response);
                this.router.navigate(['/Sucess']);
              }, error => console.error(error));

            } else {
              this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentNew", this.bookAppointment, this.options).subscribe(result => {
                this.ngxLoader.stop();
                result.response.BranchId = this.branchLoggedinId;
                result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
                result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
                result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
                result.response.CountryCode = this.CountryCode || "";
                this.globalService.setAppointmentResponce(result.response);
                this.router.navigate(['/Sucess']);
              }, error => console.error(error));
            }
          }

        }









      }, error => console.error(error));

    } else {
      this.ngxLoader.start();


      this.PaymentConfirmationObj = new PaymentConfirmationObj();

      if (this.promoCodeObj.OfferAmount === this.PaymentConfirmationObj.consultationFee && this.promoCodeObj.OfferValueType == 'Percent') {
        this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
          this.ngxLoader.stop();
          result.response.BranchId = this.branchLoggedinId;
          result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
          result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
          result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
          result.response.CountryCode = this.CountryCode || "";
          this.globalService.setAppointmentResponce(result.response);
          this.router.navigate(['/Sucess']);
        }, error => console.error(error));

      } else {
        this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentNew", this.bookAppointment, this.options).subscribe(result => {
          this.ngxLoader.stop();
          result.response.BranchId = this.branchLoggedinId;
          result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
          result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
          result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
          result.response.CountryCode = this.CountryCode || "";
          this.globalService.setAppointmentResponce(result.response);
          this.router.navigate(['/Sucess']);
        }, error => console.error(error));
      }


    }














  }


  ConfirmBookAppointment() {

     var ispayment =false; 
 if (this.OrganizationSettingsData !== undefined) {
      if (this.OrganizationSettingsData.AppointmentSettings !== undefined) {
       if (this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline !== undefined) {
  ispayment  = this.OrganizationSettingsData.AppointmentSettings.IsPaymentTakenOnline == 1 ? true : false;
  }
 }
    }


    this.bookAppointment.AppointmentID = 0;
    this.bookAppointment.ParentAppointmentId = 0;
    this.bookAppointment.RootAppointmentId = 0;
    this.bookAppointment.AppointmentStatus = 'B';
    this.bookAppointment.BookingTypeId = 2;
    this.bookAppointment.AppointmentPatientTypeId = 1;
    this.bookAppointment.IsTeleMedicineSlot = this.IsTeleSlot;
    this.bookAppointment.IsTeleMedicineTermsAndConditions = true;


    this.bookAppointment.StartTime = this.SlectedSlots.StartTime;
    this.bookAppointment.EndTime = this.SlectedSlots.EndTime;
    this.bookAppointment.DoctorID = this.SelectedDoctor.DoctorID;
    if (this.IsTeleSlot) {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserTeleConsultation[0].DayCD;
    } else {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserConsultation[0].DayCD;
    }

    this.bookAppointment.VisitUserTypeID = this.appointmentType;
    this.bookAppointment.ConsultationDt = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.bookAppointment.UserBranchId = this.SelectedUserBranchId;
    this.bookAppointment.PatientID = this.bookAppointment.PatientID ? this.bookAppointment.PatientID : 0;

    this.bookAppointment.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.bookAppointment.UserId = this.SelectedDoctor.DoctorID;
    this.bookAppointment.USRType = "DOCTOR";
    this.bookAppointment.DoctorVisitRsnID = this.appointmentType;
    this.hospitalDetails.HospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID;

    this.hospitalDetails.ParentHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId;
    this.hospitalDetails.IsSMSInd = this.SelectedHospital.HospitalInfo.HospitalDetails.IsSMSInd;
    this.hospitalDetails.SenderId = this.SelectedHospital.HospitalInfo.HospitalDetails.SenderId;
    this.hospitalDetails.LoginHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID; //sms purpose only


    this.bookAppointment.HospitalDetails = this.hospitalDetails;

    this.referralSourceDtls.ReferralID = this.referralSourceDtls.ReferralID ? this.referralSourceDtls.ReferralID : 0;
    this.referralSourceDtls.SubReferralID = this.referralSourceDtls.SubReferralID ? this.referralSourceDtls.SubReferralID : 2;


    this.bookAppointment.ReferralSourceDtls = this.referralSourceDtls;

    this.communicationDetails.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.communicationDetails.PatientMobile = this.bookAppointment.PatientMobile;
    this.communicationDetails.DoctorMobile = this.SelectedDoctor.MobileNo;
    this.communicationDetails.DoctorName = this.SelectedDoctor.FullName;
    this.communicationDetails.AppDate = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.communicationDetails.AppTime = this.SlectedSlots.StartTime;
    this.communicationDetails.AppToken = this.SlectedSlots.TokenNumber;
    this.communicationDetails.PatientEmail = this.bookAppointment.PatientEmail;
    this.communicationDetails.DoctorEmail = this.SelectedDoctor.EmailId;
    this.communicationDetails.HospitalContact = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.communicationDetails.BrnachAddress = this.SelectedHospital.HospitalInfo.HospitalAddress;
    this.communicationDetails.CommunicationEmailId = this.SelectedDoctor.CommunicationEmailId || "";
    this.communicationDetails.CommunicationMobileNo = this.SelectedDoctor.CommunicationMobileNo || "";

    this.bookAppointment.CommunicationDetails = this.communicationDetails;
    this.bookAppointment.PreviousAppointmentDate = "";
    this.bookAppointment.IsFollowUp = false;
    this.bookAppointment.SendDocSms = true;
    this.bookAppointment.SendDocEmail = true;
    this.bookAppointment.SendPatientEmail = true;
    this.bookAppointment.SendPatientSms = true;
    this.bookAppointment.PatientTypeId = 1;
    this.bookAppointment.PatientTitle = "Mr";
    this.bookAppointment.PaidFollowup = false;
    if (this.FinalCovidQuestionArray.length > 0) {
      this.FinalCovidQuestionArray.forEach((mitem, index) => {
        this.COVID19Quetions.forEach((nitem, index) => {
          if (mitem.QuestionId === nitem.QuestionId) {
            nitem.IsActive = nitem.IsActive;
          }
        });
      });
    }
    this.bookAppointment.masterQuestions = this.COVID19Quetions;
    this.bookAppointment.consultationFee = this.consultationFee;
    this.bookAppointment.avgconsultationTime = this.avgConsultationTime;


    this.bookAppointment.PromoCodeId = this.promoCodeObj.PromoCodeId || 0;
    this.bookAppointment.PromoCode = this.promoCodeObj.promoCode || "";
    this.bookAppointment.PromoCodeAmount = this.promoCodeObj.OfferAmount || 0;
    this.bookAppointment.SubSpecializationId = this.SubSpecializationId;
    this.bookAppointment.BranchSubSpecializationId = this.BranchSubSpecializationId;
    if (this.bookAppointment.PatientID !== 0) {
      var param;
      var obj = {
        "PatientId": this.bookAppointment.PatientID,
        "AppointmentDate": this.communicationDetails.AppDate,
        "HospitalId": this.hospitalDetails.HospitalID,
        "DoctorId": this.bookAppointment.DoctorID
      };
      this.ngxLoader.start();
      console.log(JSON.stringify(obj));
      param = JSON.stringify(obj);
      param = "'" + param + "'";

      this.http.post<any>(this.baseUrl + "/api/Consultation/CheckAppointment", param, this.options).subscribe(result => {

        if (result.Status) {
          this.toastr.error("This patient has an existing appointment scheduled for the same date");
          this.ngxLoader.stop();
          return false;
        } else {
          this.ngxLoader.start();

          if (this.consultationFee === 0) {
            this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
              this.ngxLoader.stop();
              result.response.BranchId = this.branchLoggedinId;
              result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
              result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
              result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
              result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
              result.response.CountryCode = this.CountryCode || "";
              this.globalService.setAppointmentResponce(result.response);
              this.router.navigate(['/Sucess']);
            }, error => console.error(error));
          } else {

            if (this.PaymentConfirmationObj.amount === 0 && this.promoCodeObj.OfferValueType == 'Percent') {
              this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
                this.ngxLoader.stop();
                result.response.BranchId = this.branchLoggedinId;
                result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
                result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
                result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
                result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
                result.response.CountryCode = this.CountryCode || "";
                this.globalService.setAppointmentResponce(result.response);
                this.router.navigate(['/Sucess']);
              }, error => console.error(error));

            } else {
              this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentNew", this.bookAppointment, this.options).subscribe(result => {
                this.ngxLoader.stop();
                result.response.BranchId = this.branchLoggedinId;
                result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
                result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
                result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
                result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
                result.response.CountryCode = this.CountryCode || "";
                this.globalService.setAppointmentResponce(result.response);
                this.router.navigate(['/Sucess']);
              }, error => console.error(error));
            }
          }

        }









      }, error => console.error(error));

    } else {
      this.ngxLoader.start();


      if (this.consultationFee === 0) {
        this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
          this.ngxLoader.stop();
          result.response.BranchId = this.branchLoggedinId;
          result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
          result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
          result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
          result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
          result.response.CountryCode = this.CountryCode || "";
          this.globalService.setAppointmentResponce(result.response);
          this.router.navigate(['/Sucess']);
        }, error => console.error(error));
      } else {

        if (this.PaymentConfirmationObj.amount === 0 && this.promoCodeObj.OfferValueType == 'Percent') {
          this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentnBilling", this.bookAppointment, this.options).subscribe(result => {
            this.ngxLoader.stop();
            result.response.BranchId = this.branchLoggedinId;
            result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
            result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
            result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
            result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
            result.response.CountryCode = this.CountryCode || "";
            this.globalService.setAppointmentResponce(result.response);
            this.router.navigate(['/Sucess']);
          }, error => console.error(error));

        } else {
          this.http.post<any>(this.baseUrl + "/api/AppointmentPlugin/AddUpdateAppointmentNew", this.bookAppointment, this.options).subscribe(result => {
            this.ngxLoader.stop();
            result.response.BranchId = this.branchLoggedinId;
            result.response.PluginHeaderImgUrl = this.PrintOrganizationSettingsData.PluginHeaderImgUrl || "";
            result.response.PluginFooterImgUrl = this.PrintOrganizationSettingsData.PluginFooterImgUrl || "";
            result.response.PluginHeaderNavigationUrl = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl || "";
            result.response.RedirectUrl = this.bookAppointment.RedirectUrl;
            result.response.CountryCode = this.CountryCode || "";
            this.globalService.setAppointmentResponce(result.response);
            this.router.navigate(['/Sucess']);
          }, error => console.error(error));
        }
      }




    }














  }

  addNewPatient() {
    this.isPaidSlot = true;
    this.IsPatientExits = false;
    this.FinalDetailScreenshow = true;
    this.bookAppointment.PatientID = 0;
    this.bookAppointment.MasterPatientId = 0;
    this.bookAppointment.FirstName = "";
    this.bookAppointment.LastName = "";
    this.bookAppointment.PatientEmail = "";
    this.bookAppointment.PatientDOB = "";
    this.bookAppointment.PatientGender = "";
    this.referralSourceDtls.ReferralID = 0;
    this.referralSourceDtls.SubReferralID = 0;

    this.http.get<any>(this.baseUrl + '/api/Patient/GetMasterReferralSource?ParentHospitalID=' + this.SelectedParentHospitalId).subscribe(result => {

      console.log(JSON.stringify(result));
      this.ngxLoader.stop();
      this.MasterReferralSouceData = result.rows;


    }, error => console.error(error));

  }


  continueWithOutDoctor() {
    this.doctorNotSelected = true;
    this.DoctorSelectionshow = false;
    this.FinalInformationshow = true;
    this.showAppointmentTypeSlection = false;
  }

  ContinueToBookAppointmentwithoutDoctor() {
    this.withOutDocFinalConfirmation = true;
    this.FinalInformationshow = false;
    console.log(this.SelectedDate);
    this.SelectedDate = new Date();
    this.bookAppointment.ConsultationDt = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
  }
  reedeemPromoCode() {
    console.log(this.promoCodeObj);

    var obj = {
      "PatientId": this.bookAppointment.PatientID,
      "PromoCode": this.promoCodeObj.promoCode,
      "PromoCodeTypeId": 1,
      "HospitalId": this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId
    };
    this.ngxLoader.start();
    var params = JSON.stringify(obj);
    params = "'" + params + "'";
    this.http.post<any>(this.baseUrl + "/api/Setting/validatePromoCode", params, this.options).subscribe(result => {
      console.log(result);
      this.ngxLoader.stop();



      if (result.status === 'Success') {

        if (result.Result.length > 0) {

          this.promoCodeObj.OfferValue = result.Result[0].OfferValue;
          this.promoCodeObj.OfferValueType = result.Result[0].OfferValueType;
          this.promoCodeObj.PromoCodeId = result.Result[0].PromoCodeId;
          if (this.promoCodeObj.OfferValueType == 'Amount') {
            this.promoCodeObj.OfferAmount = this.promoCodeObj.OfferValue;
          } else {
            this.promoCodeObj.OfferAmount = (this.PaymentConfirmationObj.consultationFee / 100) * this.promoCodeObj.OfferValue;
          }

          console.log(this.promoCodeObj.OfferAmount);

          if (this.promoCodeObj.OfferAmount >= this.PaymentConfirmationObj.consultationFee && this.promoCodeObj.OfferValueType == 'Amount') {
            this.toastr.error("Invalid Promo Code");
            this.promoCodeObj = {
              "promoCode": "",
              "promoCodeApplied": false,
              "promoCodeValid": false,
              "OfferValue": "",
              "OfferValueType": "",
              "OfferAmount": "",
              "PatientId": ""
            };
          } else if (this.promoCodeObj.OfferAmount > this.PaymentConfirmationObj.consultationFee) {
            this.toastr.error("Invalid Promo Code");
            this.promoCodeObj = {
              "promoCode": "",
              "promoCodeApplied": false,
              "promoCodeValid": false,
              "OfferValue": "",
              "OfferValueType": "",
              "OfferAmount": "",
              "PatientId": ""
            };
          } else {
            this.toastr.success("Promo Code Applied Successfully");

            var promocodeid = this.promoCodeObj.PromoCodeId;
            this.PaymentConfirmationObj.state = promocodeid.toString();

            this.PaymentConfirmationObj.address2 = this.promoCodeObj.promoCode;

            if (this.promoCodeObj.OfferAmount === this.PaymentConfirmationObj.consultationFee && this.promoCodeObj.OfferValueType == 'Percent') {

              this.PaymentConfirmationObj.country = "100%";
              this.promoCodeObj.promoCodeValid = true;
              this.PaymentConfirmationObj.amount = 0;
            } else {
              this.PaymentConfirmationObj.country = this.promoCodeObj.OfferAmount;
              this.PaymentConfirmationObj.address2 = this.promoCodeObj.promoCode;
              this.promoCodeObj.promoCodeValid = true;
              var totalAmount = this.PaymentConfirmationObj.consultationFee + this.PaymentConfirmationObj.additionalCharges - this.promoCodeObj.OfferAmount;
              var number = totalAmount.toFixed(2);
              this.PaymentConfirmationObj.amount = parseFloat(number);
            }



            this.productinfo.name = this.SelectedDoctor.FullName;
            this.productinfo.merchantId = this.ChildMerchantId;
            this.productinfo.value = this.PaymentConfirmationObj.consultationFee - this.promoCodeObj.OfferAmount;
            this.productinfo.commission = this.PaymentConfirmationObj.additionalCharges;
            this.productinfo.description = "AppointmentBooking";

            var pobj = {
              "paymentParts": [
              ]
            }
            pobj.paymentParts.push(this.productinfo)
            this.PaymentConfirmationObj.productinfo = JSON.stringify(pobj);
            this.ngxLoader.stop();
            var params = {
              "TransactionId": 0,
              "TransactionKey": "",
              "MerchentKey": "",
              "SaltKey": "",
              "PatientId": this.bookAppointment.PatientID,
              "AppointmentId": this.bookAppointment.AppointmentID,
              "UserId": this.SelectedDoctor.DoctorID,
              "FirstName": this.PaymentConfirmationObj.firstname,
              "Email": this.PaymentConfirmationObj.email,
              "Mobile": this.PaymentConfirmationObj.phone,
              "ProductType": this.PaymentConfirmationObj.productinfo,
              "Amount": this.PaymentConfirmationObj.amount,
              "Hash": "",
              "udf1": this.PaymentConfirmationObj.udf1,
              "udf2": this.PaymentConfirmationObj.udf2,
              "udf3": this.PaymentConfirmationObj.udf3,
              "udf4": this.PaymentConfirmationObj.udf4,
              "udf5": this.PaymentConfirmationObj.udf5,
              "isPaymentFromWeb": true
            };
            this.ngxLoader.start();
            this.http.post<any>(this.baseUrl + "/api/MasterPatient/createTxnHashForAppointment", params, this.options).subscribe(result => {
              console.log(result);
              if (result.Status === 'Success') {
                this.PaymentConfirmationObj.hash = result.HashKey;
                this.PaymentConfirmationObj.txnid = result.TransactionKey;
              }
              this.ngxLoader.stop();





            }, error => console.error(error));

          }


        }

      } else {


        this.promoCodeObj = {
          "promoCode": "",
          "promoCodeApplied": false,
          "promoCodeValid": false,
          "OfferValue": "",
          "OfferValueType": "",
          "OfferAmount": "",
          "PatientId": ""
        };
        this.toastr.error(result.Message);
      }

    }, error => console.error(error));
  }

  removePromoCode() {

    this.promoCodeObj = {
      "promoCode": "",
      "promoCodeApplied": false,
      "promoCodeValid": false,
      "OfferValue": "",
      "OfferValueType": "",
      "OfferAmount": "",
      "PatientId": ""
    };
    this.PaymentConfirmationObj.consultationFee = this.bookAppointment.consultationFee;
    var totalAmount = this.PaymentConfirmationObj.consultationFee + this.PaymentConfirmationObj.additionalCharges;
    var number = totalAmount.toFixed(2);
    this.PaymentConfirmationObj.amount = parseFloat(number);
    this.productinfo.name = this.SelectedDoctor.FullName;
    this.productinfo.merchantId = this.ChildMerchantId;
    this.productinfo.value = this.bookAppointment.consultationFee;
    this.productinfo.commission = this.bookAppointment.additionalCharges;
    this.productinfo.description = "AppointmentBooking";
    this.PaymentConfirmationObj.state = "";
    this.PaymentConfirmationObj.country = "";
    this.PaymentConfirmationObj.address2 = "";
    var pobj = {
      "paymentParts": [
      ]
    }
    pobj.paymentParts.push(this.productinfo)
    this.PaymentConfirmationObj.productinfo = JSON.stringify(pobj);

    var params = {
      "TransactionId": 0,
      "TransactionKey": "",
      "MerchentKey": "",
      "SaltKey": "",
      "PatientId": this.bookAppointment.PatientID,
      "AppointmentId": this.bookAppointment.AppointmentID,
      "UserId": this.SelectedDoctor.DoctorID,
      "FirstName": this.PaymentConfirmationObj.firstname,
      "Email": this.PaymentConfirmationObj.email,
      "Mobile": this.PaymentConfirmationObj.phone,
      "ProductType": this.PaymentConfirmationObj.productinfo,
      "Amount": this.PaymentConfirmationObj.amount,
      "Hash": "",
      "udf1": this.PaymentConfirmationObj.udf1,
      "udf2": this.PaymentConfirmationObj.udf2,
      "udf3": this.PaymentConfirmationObj.udf3,
      "udf4": this.PaymentConfirmationObj.udf4,
      "udf5": this.PaymentConfirmationObj.udf5,
      "isPaymentFromWeb": true
    };
    this.ngxLoader.start();
    this.http.post<any>(this.baseUrl + "/api/MasterPatient/createTxnHashForAppointment", params, this.options).subscribe(result => {
      console.log(result);
      if (result.Status === 'Success') {
        this.PaymentConfirmationObj.hash = result.HashKey;
        this.PaymentConfirmationObj.txnid = result.TransactionKey;
      }
      this.ngxLoader.stop();





    }, error => console.error(error));
  }

  PayBookAppointment() {
    this.promoCodeObj = {
      "promoCode": "",
      "promoCodeApplied": false,
      "promoCodeValid": false,
      "OfferValue": "",
      "OfferValueType": "",
      "OfferAmount": "",
      "PatientId": ""
    };
    this.bookAppointment.AppointmentID = 0;
    this.bookAppointment.ParentAppointmentId = 0;
    this.bookAppointment.RootAppointmentId = 0;
    this.bookAppointment.AppointmentStatus = 'B';
    this.bookAppointment.BookingTypeId = 2;
    if (this.bookAppointment.AppointmentPatientTypeId !== 2) {
      this.bookAppointment.AppointmentPatientTypeId = 1;
    }
    this.bookAppointment.IsTeleMedicineSlot = this.IsTeleSlot;
    //this.bookAppointment.IsTeleMedicineTermsAndConditions = true;

    console.log(this.SlectedSlots.StartTime);
    this.bookAppointment.StartTime = this.SlectedSlots.StartTime;
    this.bookAppointment.EndTime = this.SlectedSlots.EndTime;
    this.bookAppointment.DoctorID = this.SelectedDoctor.DoctorID;
    if (this.IsTeleSlot) {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserTeleConsultation[0].DayCD;
    } else {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserConsultation[0].DayCD;
    }

    this.bookAppointment.VisitUserTypeID = this.appointmentType;
    this.bookAppointment.ConsultationDt = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.bookAppointment.UserBranchId = this.SelectedUserBranchId;
    this.bookAppointment.PatientID = this.bookAppointment.PatientID ? this.bookAppointment.PatientID : 0;

    this.bookAppointment.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.bookAppointment.UserId = this.SelectedDoctor.DoctorID;
    this.bookAppointment.USRType = "DOCTOR";
    this.bookAppointment.DoctorVisitRsnID = this.appointmentType;
    this.hospitalDetails.HospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID;

    this.hospitalDetails.ParentHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId;
    this.hospitalDetails.IsSMSInd = this.SelectedHospital.HospitalInfo.HospitalDetails.IsSMSInd;
    this.hospitalDetails.SenderId = this.SelectedHospital.HospitalInfo.HospitalDetails.SenderId;
    this.hospitalDetails.LoginHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID; //sms purpose only


    this.bookAppointment.HospitalDetails = this.hospitalDetails;

    this.referralSourceDtls.ReferralID = this.referralSourceDtls.ReferralID ? this.referralSourceDtls.ReferralID : 0;
    this.referralSourceDtls.SubReferralID = this.referralSourceDtls.SubReferralID ? this.referralSourceDtls.SubReferralID : 2;


    this.bookAppointment.ReferralSourceDtls = this.referralSourceDtls;

    this.communicationDetails.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.communicationDetails.PatientMobile = this.bookAppointment.PatientMobile;
    this.communicationDetails.DoctorMobile = this.SelectedDoctor.MobileNo;
    this.communicationDetails.DoctorName = this.SelectedDoctor.FullName;
    this.communicationDetails.AppDate = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.communicationDetails.AppTime = this.SlectedSlots.StartTime;
    this.communicationDetails.AppToken = this.SlectedSlots.TokenNumber;
    this.communicationDetails.PatientEmail = this.bookAppointment.PatientEmail;
    this.communicationDetails.DoctorEmail = this.SelectedDoctor.EmailId;
    this.communicationDetails.HospitalContact = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.communicationDetails.BrnachAddress = this.SelectedHospital.HospitalInfo.HospitalAddress;
    this.communicationDetails.CommunicationEmailId = this.SelectedDoctor.CommunicationEmailId;
    this.communicationDetails.CommunicationMobileNo = this.SelectedDoctor.CommunicationMobileNo;

    this.bookAppointment.CommunicationDetails = this.communicationDetails;
    this.bookAppointment.PreviousAppointmentDate = "";
    this.bookAppointment.IsFollowUp = false;
    this.bookAppointment.SendDocSms = true;
    this.bookAppointment.SendDocEmail = true;
    this.bookAppointment.SendPatientEmail = true;
    this.bookAppointment.SendPatientSms = true;
    this.bookAppointment.PatientTypeId = 1;
    this.bookAppointment.PatientTitle = "Mr";
    this.bookAppointment.PaidFollowup = false;

    this.bookAppointment.SubSpecializationId = this.SubSpecializationId;
    this.bookAppointment.BranchSubSpecializationId = this.BranchSubSpecializationId;
    if (this.FinalCovidQuestionArray.length > 0) {
      this.FinalCovidQuestionArray.forEach((mitem, index) => {
        this.COVID19Quetions.forEach((nitem, index) => {
          if (mitem.QuestionId === nitem.QuestionId) {
            nitem.IsActive = nitem.IsActive;
          }
        });
      });
    }
    this.bookAppointment.masterQuestions = this.COVID19Quetions;


    console.log(this.consultationFee + "__" + this.additionalCharges + "__" + this.totalAmount + "__" + this.ChildMerchantId);



    this.consultationFee = this.consultationFee || 0;
    this.additionalCharges = this.additionalCharges || 0;
    this.totalAmount = this.totalAmount || 0;
    this.ChildMerchantId = this.ChildMerchantId || "";


    ////Comment for stage and Production
    //this.consultationFee = 2;
    //this.additionalCharges = 1;
    //this.totalAmount = this.consultationFee + this.additionalCharges;

    //if (this.consultationFee === 0) {
    //  this.toastr.error("Doctor dosent added any consultation charges..");
    //  return false;
    //}

    //if (this.additionalCharges === 0) {
    //  this.toastr.error("Doctor dosent added any additional charges..");
    //  return false;
    //}
    //if (this.ChildMerchantId === "") {
    //  this.toastr.error("Doctor dosent have payment gateway credentials..");
    //  return false;
    //}

    this.bookAppointment.consultationFee = this.consultationFee;
    this.bookAppointment.additionalCharges = this.additionalCharges;
    this.bookAppointment.totalAmount = this.totalAmount;

    this.bookAppointment.avgconsultationTime = this.avgConsultationTime;


    this.productinfo.name = this.SelectedDoctor.FullName;
    this.productinfo.merchantId = this.ChildMerchantId;
    this.productinfo.value = this.bookAppointment.consultationFee;
    this.productinfo.commission = this.bookAppointment.additionalCharges;
    this.productinfo.description = "AppointmentBooking";

    var pobj = {
      "paymentParts": [
      ]
    }
    pobj.paymentParts.push(this.productinfo)
    this.bookAppointment.Productinfo = pobj
    this.ngxLoader.start();

    this.bookAppointment.ProductType = JSON.stringify(pobj);
    this.bookAppointment.Amount = this.bookAppointment.totalAmount;
    this.bookAppointment.TransactionId = 0;
    this.bookAppointment.udf1 = this.bookAppointment.CommunicationDetails.DoctorName;
    this.bookAppointment.udf2 = this.bookAppointment.CommunicationDetails.AppDate.toString();
    this.bookAppointment.udf3 = this.bookAppointment.CommunicationDetails.AppTime.toString();
    this.bookAppointment.udf4 = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalName;
    this.bookAppointment.udf5 = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber.toString();


    var param;
    var obj = {
      "PatientId": this.bookAppointment.PatientID,
      "AppointmentDate": this.communicationDetails.AppDate,
      "HospitalId": this.hospitalDetails.HospitalID,
      "DoctorId": this.bookAppointment.DoctorID
    };




    this.ngxLoader.start();

    param = JSON.stringify(obj);
    param = "'" + param + "'";
    if (this.bookAppointment.PatientID !== 0) {
      this.http.post<any>(this.baseUrl + "/api/Consultation/CheckAppointment", param, this.options).subscribe(result => {

        if (result.Status) {
          this.toastr.error("This patient has an existing appointment scheduled for the same date");
          this.ngxLoader.stop();
          this.ConsentFormSign = true;
          return false;
        } else {
          this.ngxLoader.start();


          console.log(this.bookAppointment);
          this.http.post<any>(this.baseUrl + "/api/Patient/AddUpdateAppointmentForPlugin", this.bookAppointment, this.options).subscribe(result => {
            this.ngxLoader.stop();
            console.log(JSON.stringify(result));
            if (result.status === 'success') {
              this.bookAppointment.hash = result.response.Hash;
              this.bookAppointment.txnid = result.response.TransactionKey;
              //this.bookAppointment.udf2 = result.response.AppointmentID.toString();
              //this.bookAppointment.udf3 = result.response.TransactionId.toString();
              this.bookAppointment.AppointmentID = result.response.AppointmentID;
              this.bookAppointment.zipcode = result.response.AppointmentID;
              this.bookAppointment.city = this.branchLoggedinId;
              this.globalService.setbookAppointmentData(this.bookAppointment);
              //this.router.navigate(['/Payment']);


              this.promoCodeObj.PatientId = this.bookAppointment.PatientID;


              this.selectedBooAppointmentData = this.globalService.getbookAppointmentData();
              this.PaymentConfirmationObj = new PaymentConfirmationObj();

              this.PaymentConfirmationObj.firstname = this.selectedBooAppointmentData.FirstName;
              this.PaymentConfirmationObj.email = this.selectedBooAppointmentData.PatientEmail;
              this.PaymentConfirmationObj.phone = this.selectedBooAppointmentData.PatientMobile;
              this.PaymentConfirmationObj.amount = this.selectedBooAppointmentData.totalAmount;
              this.PaymentConfirmationObj.appointmentdate = this.selectedBooAppointmentData.ConsultationDt;
              var currentDate = new Date();
              this.PaymentConfirmationObj.appointmenttime = this.selectedBooAppointmentData.StartTime;
              this.PaymentConfirmationObj.slotTime = this.selectedBooAppointmentData.avgconsultationTime;
              this.PaymentConfirmationObj.doctorname = this.selectedBooAppointmentData.CommunicationDetails.DoctorName;
              this.PaymentConfirmationObj.doctormobile = this.selectedBooAppointmentData.CommunicationDetails.DoctorMobile;
              this.PaymentConfirmationObj.doctoremail = this.selectedBooAppointmentData.CommunicationDetails.DoctorEmail;
              this.PaymentConfirmationObj.CommunicationEmailId = this.selectedBooAppointmentData.CommunicationDetails.CommunicationEmailId;
              this.PaymentConfirmationObj.CommunicationMobileNo = this.selectedBooAppointmentData.CommunicationDetails.CommunicationMobileNo;
              this.PaymentConfirmationObj.key = "xxz1z6X2";
              this.PaymentConfirmationObj.productinfo = this.selectedBooAppointmentData.ProductType;
              this.PaymentConfirmationObj.service_provider = "payu_paisa";


              var surl = "";
              surl = this.baseUrl + "/Home/PaymentResultSuccess";
              console.log(surl);

              var furl = "";
              furl = this.baseUrl + "/Home/PaymentResultFailure";



              this.PaymentConfirmationObj.surl = surl;
              this.PaymentConfirmationObj.furl = furl;
              this.PaymentConfirmationObj.hash = this.selectedBooAppointmentData.hash;
              this.PaymentConfirmationObj.txnid = this.selectedBooAppointmentData.txnid;
              this.PaymentConfirmationObj.udf1 = this.selectedBooAppointmentData.udf1;
              this.PaymentConfirmationObj.udf2 = this.selectedBooAppointmentData.udf2;
              this.PaymentConfirmationObj.udf3 = this.selectedBooAppointmentData.udf3;
              this.PaymentConfirmationObj.udf4 = this.selectedBooAppointmentData.udf4;
              this.PaymentConfirmationObj.udf5 = this.selectedBooAppointmentData.udf5;
              this.PaymentConfirmationObj.consultationFee = this.selectedBooAppointmentData.consultationFee;
              this.PaymentConfirmationObj.additionalCharges = this.selectedBooAppointmentData.additionalCharges;
              this.PaymentConfirmationObj.totalCost = this.selectedBooAppointmentData.totalAmount;
              this.PaymentConfirmationObj.zipcode = this.selectedBooAppointmentData.zipcode;
              this.PaymentConfirmationObj.city = this.selectedBooAppointmentData.city;
              this.PaymentConfirmationObj.IsTeleMedicineSlot = this.selectedBooAppointmentData.IsTeleMedicineSlot;
              this.PaymentConfirmationObj.parentHospitalId = this.selectedBooAppointmentData.city;
              console.log(this.selectedBooAppointmentData.RedirectUrl);

              var AppType = "Appointment";
              if (this.IsTeleSlot) {
                AppType = "Tele Appointment";
              }
              this.PaymentConfirmationObj.address1 = AppType;
              this.PaymentConfirmationObj.state = "";
              this.PaymentConfirmationObj.country = "";
              this.PaymentConfirmationObj.address2 = "";
              this.FinalInformationshow = false;
              this.CovidQuetionss = false;
              this.ConsentFormSign = false;
              this.ShowPaymentForm = true;
            }
            else {
              this.toastr.success("Something Went Wrong");
            }
          }, error => {
            this.ngxLoader.stop();
            console.error(error)
          });

        }

      }, error => console.error(error));
    } else {
      this.http.post<any>(this.baseUrl + "/api/Patient/AddUpdateAppointmentForPlugin", this.bookAppointment, this.options).subscribe(result => {
        this.ngxLoader.stop();
        console.log(JSON.stringify(result));
        if (result.status === 'success') {
          this.bookAppointment.hash = result.response.Hash;
          this.bookAppointment.txnid = result.response.TransactionKey;
          //this.bookAppointment.udf2 = result.response.AppointmentID.toString();
          //this.bookAppointment.udf3 = result.response.TransactionId.toString();
          this.bookAppointment.zipcode = result.response.AppointmentID;
          this.bookAppointment.city = this.branchLoggedinId;
          this.globalService.setbookAppointmentData(this.bookAppointment);
          //this.router.navigate(['/Payment']);
          this.bookAppointment.AppointmentID = result.response.AppointmentID;
          this.promoCodeObj.PatientId = this.bookAppointment.PatientID;

          this.selectedBooAppointmentData = this.globalService.getbookAppointmentData();
          this.PaymentConfirmationObj = new PaymentConfirmationObj();

          this.PaymentConfirmationObj.firstname = this.selectedBooAppointmentData.FirstName;
          this.PaymentConfirmationObj.email = this.selectedBooAppointmentData.PatientEmail;
          this.PaymentConfirmationObj.phone = this.selectedBooAppointmentData.PatientMobile;
          this.PaymentConfirmationObj.amount = this.selectedBooAppointmentData.totalAmount;
          this.PaymentConfirmationObj.appointmentdate = this.selectedBooAppointmentData.ConsultationDt;
          var currentDate = new Date();
          this.PaymentConfirmationObj.appointmenttime = this.selectedBooAppointmentData.StartTime;
          this.PaymentConfirmationObj.slotTime = this.selectedBooAppointmentData.avgconsultationTime;
          this.PaymentConfirmationObj.doctorname = this.selectedBooAppointmentData.CommunicationDetails.DoctorName;
          this.PaymentConfirmationObj.doctormobile = this.selectedBooAppointmentData.CommunicationDetails.DoctorMobile;
          this.PaymentConfirmationObj.doctoremail = this.selectedBooAppointmentData.CommunicationDetails.DoctorEmail;
          this.PaymentConfirmationObj.key = "xxz1z6X2";
          this.PaymentConfirmationObj.productinfo = this.selectedBooAppointmentData.ProductType;
          this.PaymentConfirmationObj.service_provider = "payu_paisa";
          this.PaymentConfirmationObj.state = "";
          this.PaymentConfirmationObj.country = "";
          this.PaymentConfirmationObj.address2 = "";
          this.PaymentConfirmationObj.CommunicationMobileNo = this.selectedBooAppointmentData.CommunicationDetails.CommunicationMobileNo;
          this.PaymentConfirmationObj.CommunicationEmailId = this.selectedBooAppointmentData.CommunicationDetails.CommunicationEmailId;

          var surl = "";
          surl = this.baseUrl + "/Home/PaymentResultSuccess";
          console.log(surl);

          var furl = "";
          furl = this.baseUrl + "/Home/PaymentResultFailure";



          this.PaymentConfirmationObj.surl = surl;
          this.PaymentConfirmationObj.furl = furl;
          this.PaymentConfirmationObj.hash = this.selectedBooAppointmentData.hash;
          this.PaymentConfirmationObj.txnid = this.selectedBooAppointmentData.txnid;
          this.PaymentConfirmationObj.udf1 = this.selectedBooAppointmentData.udf1;
          this.PaymentConfirmationObj.udf2 = this.selectedBooAppointmentData.udf2;
          this.PaymentConfirmationObj.udf3 = this.selectedBooAppointmentData.udf3;
          this.PaymentConfirmationObj.udf4 = this.selectedBooAppointmentData.udf4;
          this.PaymentConfirmationObj.udf5 = this.selectedBooAppointmentData.udf5;
          this.PaymentConfirmationObj.consultationFee = this.selectedBooAppointmentData.consultationFee;
          this.PaymentConfirmationObj.additionalCharges = this.selectedBooAppointmentData.additionalCharges;
          this.PaymentConfirmationObj.totalCost = this.selectedBooAppointmentData.totalAmount;
          this.PaymentConfirmationObj.zipcode = this.selectedBooAppointmentData.zipcode;
          this.PaymentConfirmationObj.city = this.selectedBooAppointmentData.city;
          this.PaymentConfirmationObj.IsTeleMedicineSlot = this.selectedBooAppointmentData.IsTeleMedicineSlot;
          this.PaymentConfirmationObj.parentHospitalId = this.selectedBooAppointmentData.city;
          console.log(this.selectedBooAppointmentData.RedirectUrl);
          var AppType = "Appointment";
          if (this.IsTeleSlot) {
            AppType = "Tele Appointment";
          }
          this.PaymentConfirmationObj.address1 = AppType;




          this.CovidQuetionss = false;
          this.ShowPaymentForm = true;
        }
        else {
          this.toastr.success("Something Went Wrong");
        }
      }, error => {
        this.ngxLoader.stop();
        console.error(error)
      });
    }


  }

  ConfirmAppointment() {
    this.promoCodeObj = {
      "promoCode": "",
      "promoCodeApplied": false,
      "promoCodeValid": false,
      "OfferValue": "",
      "OfferValueType": "",
      "OfferAmount": "",
      "PatientId": ""
    };
    this.bookAppointment.AppointmentID = 0;
    this.bookAppointment.ParentAppointmentId = 0;
    this.bookAppointment.RootAppointmentId = 0;
    this.bookAppointment.AppointmentStatus = 'B';
    this.bookAppointment.BookingTypeId = 2;
    if (this.bookAppointment.AppointmentPatientTypeId !== 2) {
      this.bookAppointment.AppointmentPatientTypeId = 1;
    }
    this.bookAppointment.IsTeleMedicineSlot = this.IsTeleSlot;










    console.log(this.SlectedSlots.StartTime);
    this.bookAppointment.StartTime = this.SlectedSlots.StartTime;
    this.bookAppointment.EndTime = this.SlectedSlots.EndTime;
    this.bookAppointment.DoctorID = this.SelectedDoctor.DoctorID;
    if (this.IsTeleSlot) {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserTeleConsultation[0].DayCD;
    } else {
      this.bookAppointment.DayCD = this.doctorBookedSlots.UserConsultation[0].DayCD;
    }

    this.bookAppointment.VisitUserTypeID = this.appointmentType;
    this.bookAppointment.ConsultationDt = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.bookAppointment.UserBranchId = this.SelectedUserBranchId;
    this.bookAppointment.PatientID = this.bookAppointment.PatientID ? this.bookAppointment.PatientID : 0;

    this.bookAppointment.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.bookAppointment.UserId = this.SelectedDoctor.DoctorID;
    this.bookAppointment.USRType = "DOCTOR";
    this.bookAppointment.DoctorVisitRsnID = this.appointmentType;
    this.hospitalDetails.HospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID;

    this.hospitalDetails.ParentHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId;
    this.hospitalDetails.IsSMSInd = this.SelectedHospital.HospitalInfo.HospitalDetails.IsSMSInd;
    this.hospitalDetails.SenderId = this.SelectedHospital.HospitalInfo.HospitalDetails.SenderId;
    this.hospitalDetails.LoginHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID; //sms purpose only


    this.bookAppointment.HospitalDetails = this.hospitalDetails;

    this.referralSourceDtls.ReferralID = this.referralSourceDtls.ReferralID ? this.referralSourceDtls.ReferralID : 0;
    this.referralSourceDtls.SubReferralID = this.referralSourceDtls.SubReferralID ? this.referralSourceDtls.SubReferralID : 2;


    this.bookAppointment.ReferralSourceDtls = this.referralSourceDtls;

    this.communicationDetails.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.communicationDetails.PatientMobile = this.bookAppointment.PatientMobile;
    this.communicationDetails.DoctorMobile = this.SelectedDoctor.MobileNo;
    this.communicationDetails.DoctorName = this.SelectedDoctor.FullName;
    this.communicationDetails.AppDate = this.datePipe.transform(this.SelectedDate, 'yyyy-MM-dd');
    this.communicationDetails.AppTime = this.SlectedSlots.StartTime;
    this.communicationDetails.AppToken = this.SlectedSlots.TokenNumber;
    this.communicationDetails.PatientEmail = this.bookAppointment.PatientEmail;
    this.communicationDetails.DoctorEmail = this.SelectedDoctor.EmailId;
    this.communicationDetails.HospitalContact = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.communicationDetails.BrnachAddress = this.SelectedHospital.HospitalInfo.HospitalAddress;
    this.communicationDetails.CommunicationEmailId = this.SelectedDoctor.CommunicationEmailId;
    this.communicationDetails.CommunicationMobileNo = this.SelectedDoctor.CommunicationMobileNo;

    this.bookAppointment.CommunicationDetails = this.communicationDetails;
    this.bookAppointment.PreviousAppointmentDate = "";
    this.bookAppointment.IsFollowUp = false;
    this.bookAppointment.SendDocSms = true;
    this.bookAppointment.SendDocEmail = true;
    this.bookAppointment.SendPatientEmail = true;
    this.bookAppointment.SendPatientSms = true;
    this.bookAppointment.PatientTypeId = 1;
    this.bookAppointment.PatientTitle = "Mr";
    this.bookAppointment.PaidFollowup = false;
    if (this.FinalCovidQuestionArray.length > 0) {
      this.FinalCovidQuestionArray.forEach((mitem, index) => {
        this.COVID19Quetions.forEach((nitem, index) => {
          if (mitem.QuestionId === nitem.QuestionId) {
            nitem.IsActive = nitem.IsActive;
          }
        });
      });
    }
    this.bookAppointment.masterQuestions = this.COVID19Quetions;


    console.log(this.consultationFee + "__" + this.additionalCharges + "__" + this.totalAmount + "__" + this.ChildMerchantId);



    this.consultationFee = this.consultationFee || 0;
    this.additionalCharges = this.additionalCharges || 0;
    this.totalAmount = this.totalAmount || 0;
    this.ChildMerchantId = this.ChildMerchantId || "";


    this.bookAppointment.consultationFee = this.consultationFee;
    this.bookAppointment.additionalCharges = this.additionalCharges;
    this.bookAppointment.totalAmount = this.totalAmount;

    this.bookAppointment.avgconsultationTime = this.avgConsultationTime;


    this.productinfo.name = this.SelectedDoctor.FullName;
    this.productinfo.merchantId = this.ChildMerchantId;
    this.productinfo.value = this.bookAppointment.consultationFee;
    this.productinfo.commission = this.bookAppointment.additionalCharges;
    this.productinfo.description = "AppointmentBooking";

    var pobj = {
      "paymentParts": [
      ]
    }
    pobj.paymentParts.push(this.productinfo)
    this.bookAppointment.Productinfo = pobj
    this.ngxLoader.start();

    this.bookAppointment.ProductType = JSON.stringify(pobj);
    this.bookAppointment.Amount = this.bookAppointment.totalAmount;
    this.bookAppointment.TransactionId = 0;
    this.bookAppointment.udf1 = this.bookAppointment.CommunicationDetails.DoctorName;
    this.bookAppointment.udf2 = this.bookAppointment.CommunicationDetails.AppDate.toString();
    this.bookAppointment.udf3 = this.bookAppointment.CommunicationDetails.AppTime.toString();
    this.bookAppointment.udf4 = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalName;
    this.bookAppointment.udf5 = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber.toString();


    var param;
    var obj = {
      "PatientId": this.bookAppointment.PatientID,
      "AppointmentDate": this.communicationDetails.AppDate,
      "HospitalId": this.hospitalDetails.HospitalID,
      "DoctorId": this.bookAppointment.DoctorID
    };


    this.PaymentConfirmationObj = new PaymentConfirmationObj();
    this.globalService.setbookAppointmentData(this.bookAppointment);
    this.promoCodeObj.PatientId = this.bookAppointment.PatientID;
    this.selectedBooAppointmentData = this.globalService.getbookAppointmentData();
    this.PaymentConfirmationObj = new PaymentConfirmationObj();
    this.PaymentConfirmationObj.firstname = this.selectedBooAppointmentData.FirstName;
    this.PaymentConfirmationObj.email = this.selectedBooAppointmentData.PatientEmail;
    this.PaymentConfirmationObj.phone = this.selectedBooAppointmentData.PatientMobile;
    this.PaymentConfirmationObj.amount = this.selectedBooAppointmentData.totalAmount;
    this.PaymentConfirmationObj.appointmentdate = this.selectedBooAppointmentData.ConsultationDt;
    var currentDate = new Date();
    this.PaymentConfirmationObj.appointmenttime = this.selectedBooAppointmentData.StartTime;
    this.PaymentConfirmationObj.slotTime = this.selectedBooAppointmentData.avgconsultationTime;
    this.PaymentConfirmationObj.doctorname = this.selectedBooAppointmentData.CommunicationDetails.DoctorName;
    this.PaymentConfirmationObj.doctormobile = this.selectedBooAppointmentData.CommunicationDetails.DoctorMobile;
    this.PaymentConfirmationObj.doctoremail = this.selectedBooAppointmentData.CommunicationDetails.DoctorEmail;
    this.PaymentConfirmationObj.CommunicationEmailId = this.selectedBooAppointmentData.CommunicationDetails.CommunicationEmailId;
    this.PaymentConfirmationObj.CommunicationMobileNo = this.selectedBooAppointmentData.CommunicationDetails.CommunicationMobileNo;
    this.PaymentConfirmationObj.consultationFee = this.selectedBooAppointmentData.consultationFee;
    this.PaymentConfirmationObj.additionalCharges = this.selectedBooAppointmentData.additionalCharges;
    this.PaymentConfirmationObj.totalCost = this.selectedBooAppointmentData.totalAmount;

    this.ngxLoader.start();

    param = JSON.stringify(obj);
    param = "'" + param + "'";
    if (this.bookAppointment.PatientID !== 0) {
      this.http.post<any>(this.baseUrl + "/api/Consultation/CheckAppointment", param, this.options).subscribe(result => {
        this.ngxLoader.stop();
        if (result.Status) {
          this.toastr.error("This patient has an existing appointment scheduled for the same date");

          this.ConsentFormSign = true;
          return false;
        } else {
          this.FinalInformationshow = false;
          this.CovidQuetionss = false;
          this.ConsentFormSign = false;
          this.ShowPaymentForm = true;
        }

      }, error => console.error(error));
    } else {
      this.FinalInformationshow = false;
      this.CovidQuetionss = false;
      this.ConsentFormSign = false;
      this.ShowPaymentForm = true;
      this.ngxLoader.stop();
    }


  }

  navPayBookAppointment() {
    this.CovidQuetionss = false;
    this.ShowPaymentForm = false;
    this.ConsentFormSign = true;
  }

  acceptTermsandConditions() {

    this.bookAppointment.IsTeleMedicineTermsAndConditions = true;
    this.ConsentFormSign = false;
    if (this.consultationFee === 0) {
      this.ConfirmAppointment();
    } else {
      this.PayBookAppointment();
    }

  }



  BackToCovidQuestions(): void {
    this.ShowPaymentForm = false;
    this.ConsentFormSign = false;
    this.CovidQuetionss = true;
    this.filtertypeInd = true;
    this.bookAppointment.IsTeleMedicineTermsAndConditions = false;
  }

  savenCreateLead() {

    console.log(this.bookAppointment.ConsultationDt);



    var params = {
      "LeadId": null,
      "Name": this.bookAppointment.FirstName,
      "Gender": this.bookAppointment.PatientGender,
      "Age": this.bookAppointment.PatientAge,
      "Mobile": this.bookAppointment.PatientMobile,
      "sendPatientSms": true,
      "LeadSourceId": 1,
      "LeadSourceName": "News Paper",
      "LocationName": this.SelectedCity,
      "CityName": this.SelectedCity,
      "StateName": "",
      "CountryName": "",
      "Problem": this.bookAppointment.Problem,
      "Remarks": "",
      "IsAppointmentChecked": "",
      "IsCallBackChecked": false,
      "CallBackDate": this.bookAppointment.ConsultationDt,
      "CallBackDt": this.bookAppointment.ConsultationDt,
      "CreatedBy": 1,
      "AssignedTo": 1,
      "RoleId": 1,
      "OrganizationId": this.SelectedParentHospitalId,
      "AssignedToEmail": "",
      "NamePrefix": "Mr",
      "LeadStatusId": 1,
      "AppointmentChecked": false,
      "CallBackChecked": false,
      "Email": this.bookAppointment.PatientEmail,
      "Area": "",
      "UserId": 1,
      "LeadFromExternal": true
    }

    this.ngxLoader.start();
    console.log(params);
    //return false;
    this.http.post<any>(this.baseUrl + "/api/Leads/SaveLead", params, this.options).subscribe(result => {
      console.log(result);
      if (result.Message === 'Success') {
        // this.toastr.success("Added Successfully,Shortly our team will get back in touch with you");
        this.ShowSuccessForm = true;
      }
      this.ngxLoader.stop();





    }, error => console.error(error));


  }

  navtoMainUrl() {
    if (this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl !== "") {
      window.location.href = this.PrintOrganizationSettingsData.PluginHeaderNavigationUrl;
    } else {
      window.location.href = this.bookAppointment.RedirectUrl;
    }
  }
  selectDoctorBranch(item, mitem, mindex,type) {
    this.SelectedHospitalId = item.BranchId;

    if (type=="1") {
      this.searchDoctorsObj.BranchId = item.BranchId;
      this.searchDoctorsObj.CityId = item.CityId;
    }
    this.SelectedDoctor.UserSubSpecialization = item.UserSubSpecialization || [];
    console.log(this.SelectedDoctor.UserSubSpecialization);
    if (this.SelectedDoctor.UserSubSpecialization.length > 0) {
      this.SelectedDoctor.UserSubSpecialization.forEach((kitem, index) => {
        if (kitem.IsPrimarySubSpecialization === true) {
          this.BranchSubSpecializationId = kitem.BranchSubSpecializationId;
          this.SubSpecializationId = kitem.SubSpecializationId;
        }
      });
    }
    console.log(this.BranchSubSpecializationId);
    console.log(this.SubSpecializationId);
    console.log(item);
    this.SelectedCity = item.CityName;
 
    this.SelectedUserBranchId = item.UserBranchId;
    this.SelectedDoctorId = mitem.DoctorID;
    mitem.IsDoctorSlotAvailable = item.IsDoctorSlotAvailable;
    mitem.IsDoctorTeleSlotAvailable = item.IsDoctorTeleSlotAvailable;

    mitem.NextAvailableNormalSlot = item.NextAvailableNormalSlot;
    mitem.NextAvailableTeleSlot = item.NextAvailableTeleSlot;
    this.SelectedDate = new Date();

    var Hospitalselected = this.HospitalDoctorData.filter((item) => item.HospitalInfo.HospitalDetails.HospitalID == this.SelectedHospitalId);
    var user = Hospitalselected[0];
    this.SelectedHospital = user;
    this.SelectedDoctorData.forEach((citem, index) => {
      citem.isDoctorSelected = false;
    });
    mitem.isDoctorSelected = true;
    this.GetSoltes();

    var param;
    var datePipe = new DatePipe('en-US');
    var obj = {
      "Date": datePipe.transform(this.SelectedDate, 'yyyy-MM-dd'),
      "UserBranchId": this.SelectedUserBranchId,
      "DoctorId": this.SelectedDoctorId
    }

    this.ngxLoader.start();
    mitem.ConsultationFee = 0;
    mitem.TeleConsultationFee = 0;


    param = JSON.stringify(obj);
    param = "'" + param + "'";

    this.http.post<any>(this.baseUrl + "/api/Patient/GetDoctorBookedslots", param, this.options).subscribe(result => {
      this.doctorBookedSlots = result;
      console.log(result);
      this.ngxLoader.stop();
      mitem.showConsultationFee = false;
      mitem.showTeleConsultationFee = false;
      mitem.ConsultationFee = result.ConsultationFee || 0;
      mitem.TeleConsultationFee = result.TeleConsultationFee || 0;


      if (mitem.ConsultationFee !== 0) {
        mitem.showConsultationFee = true;
      }
      if (mitem.TeleConsultationFee !== 0) {
        mitem.showTeleConsultationFee = true;
      }

      if (mitem.NextAvailableNormalSlot == "") {
        mitem.NextAvailableNormalSlot = "N/A";
      } else {
        mitem.NextAvailableNormalSlot = this.datePipe.transform(mitem.NextAvailableNormalSlot, 'dd/MM/yyyy')
      }

      if (mitem.NextAvailableTeleSlot == "") {
        mitem.NextAvailableTeleSlot = "N/A";
      } else {
        mitem.NextAvailableTeleSlot = this.datePipe.transform(mitem.NextAvailableTeleSlot, 'dd/MM/yyyy')
      }

      this.restructreDoctorSlots()




    }, error => console.error(error));
  }


  getSubOrgSpecializations() {



    this.http.get<any>(this.baseUrl + '/api/MasterAdmins/GetAllSubSpecializationsByOrgId?SubOrganizationId=' + this.SelectedSubOrganizationId).subscribe(result => {
      console.log(result);
      this.BranchSubSpecializationList = [];
      this.BranchSubSpecializationList = result.row;


      this.BranchSubSpecializationList = this.BranchSubSpecializationList.filter(
        (thing, i, arr) => arr.findIndex(t => t.SubSpecializationId === thing.SubSpecializationId) === i
      );
      var allBranchSpecializationObj = {
        "BranchSubSpecializationId": 0,
        "SpecializationId": 0,
        "SubSpecializationId": 0,
        "SubSpecializationName": "All Specializations"
      };
      this.searchDoctorsObj.SubSpecializationId = 0;
      this.searchDoctorsObj.AllSubSpecializationInd = 1;
      this.BranchSubSpecializationList.unshift(allBranchSpecializationObj);

    }, error => console.error(error));

  }

  switchTab(type) {
    this.showTeleType = type;
  }
}



// WEBPACK FOOTER //
// ./src/app/appointment/appointment.component.ts